// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.2.8_@swc+helpers@0.5.15__webpack@5.91.0_esbuild@0.20.2_webpack-cli@3.3.12_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.2.8_@swc+helpers@0.5.15__webpack@5.91.0_esbuild@0.20.2_webpack-cli@3.3.12_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Variables */
:root {
  --athens-gray: #efeff0;
  --athens-gray-rgb: 239, 239, 240;
  --light-sky-gray: #f4f4f7;
  --light-sky-gray-rgb: 244, 244, 247;
  --port-gore: #1c1740;
  --port-gore-rgb: 28, 23, 64;
  --storm-gray: #706e80;
  --storm-gray-rgb: 112, 110, 128;
  --vortex-blue: #109cf1;
  --vortex-blue-rgb: 16, 156, 241;
  --vortex-deep-blue: #172b4d;
  --vortex-deep-blue-rgb: 23, 43, 77;
  --vortex-green: #1fa463;
  --vortex-green-rgb: 31, 164, 99;
  --vortex-orange: #fe8663;
  --vortex-orange-rgb: 254, 134, 99;
  --vortex-red: #ff5c5c;
  --vortex-red-rgb: 255, 92, 92;
  --white: #ffffff;
  --white-rgb: 255, 255, 255;
}
/* Grid Breakpoints */
/* Frontend */
body {
  color: #1c1740;
  color: var(--port-gore);
}
a {
  color: inherit;
}
a:hover {
  color: inherit;
  -webkit-text-decoration: none;
  text-decoration: none;
}
.aside {
  display: flex;
  flex-flow: column;
  position: relative;
  background-color: #ffffff;
  background-color: var(--white);
  border-right: 2px solid #dee3ec;
}
@media (min-width: 992px) {
  .aside {
    position: sticky;
    height: 100vh;
    top: 0;
    overflow-y: auto;
  }
}
.aside-user {
  padding: 12px 10px 10px;
  margin-top: auto;
}
.aside__hamburger {
  position: absolute;
  top: -66px;
}
.ellipsis-button {
  border: 0 none;
  background-color: transparent;
  color: rgba(23, 43, 77, 0.5);
  color: rgba(var(--vortex-deep-blue-rgb), 0.5);
  transition: color 0.1s ease;
  cursor: pointer;
}
.ellipsis-button:hover {
  color: rgba(23, 43, 77, 1);
  color: rgba(var(--vortex-deep-blue-rgb), 1);
}
.ellipsis-button:focus {
  outline: none;
}
.trash-bin-button {
  color: #1c1740;
  color: var(--port-gore);
  opacity: 0.2;
  transition: opacity 0.1s ease;
  font-size: 17px;
  cursor: pointer;
}
.trash-bin-button:hover {
  opacity: 0.5;
}
.tmp-fly-btn--primary {
  color: rgb(249, 251, 255) !important;
  background-color: rgb(56, 105, 199) !important;
  border-color: rgb(56, 105, 199) !important;
}
.tmp-fly-border-btn {
  border: 1px solid rgb(222, 227, 236);
}
.tmp-fly-btn {
  padding: 11px 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0px;
  border-width: 2px;
  border-style: solid;
  border-radius: 6px;
  cursor: pointer;
  background: rgb(255, 255, 255);
  color: rgb(127, 122, 147);
  border-color: rgb(222, 227, 236);
}
.user {
  display: flex;
  align-items: center;
}
.user__avatar {
    border-radius: 100%;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 38px;
    height: 38px;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.9);
    font-weight: bold;
    font-size: 16px;
  }
.user-profile {
    max-width: 1100px;
  }
@media screen and (max-width: 768px) {
.user-profile > .row {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center
    }
      }
.user-profile__information {
      padding: 2rem;
    }
.user-profile__avatar-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      max-width: 300px;
    }
@media screen and (min-width: 576px) {
.user-profile__avatar-wrapper {
        justify-content: flex-start;
        align-items: flex-start;
        max-width: 150px
    }
      }
.user-profile hr {
      border-top: 0;
      border-bottom: 1px solid rgba(23, 43, 77, 0.07);
      border-bottom: 1px solid rgba(var(--vortex-deep-blue-rgb), 0.07);
    }
.user-profile .user__avatar {
      width: 100%;
      padding-bottom: 100%;
      height: 0;
      border-radius: 4px;
      position: relative;
    }
.user-profile .user__avatar-initial {
        position: absolute;
        display: flex;
        width: 100%;
        height: 100%;
        justify-content: center;
        align-items: center;
        font-size: 4rem;
        top: 0;
      }
@media screen and (min-width: 768px) {
.user-profile .user__avatar {
        max-width: 200px
    }
      }
@media screen and (max-width: 768px) {
.user-profile .user__avatar {
        margin-right: 0 !important
    }
      }
.user__nickname {
    word-wrap: break-word; /* old name */
    word-wrap: break-word;
  }
.user__menu {
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
.user__menu .circle {
      width: 5px;
      height: 5px;
      margin: 3px;
      background: #efeff0;
      background: var(--athens-gray);
      border-radius: 50%;
      display: block;
      transition: background 0.2s;
    }
.user__menu > div {
      width: 60px;
      height: 60px;
      padding: 20px;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
    }
.user__menu > div:hover, .user__menu > div:focus {
        outline: none;
      }
.user__menu > span {
      display: inline-block;
      text-align: center;
      line-height: 1.2;
      padding: 20px;
      margin-top: auto;
    }
.user__menu-button {
      flex-direction: column;
      position: relative;
      transition: all 300ms cubic-bezier(0.175, 0.885, 0.32, 1.275);
    }
.user__menu-button:hover .circle, .user__menu-button:focus .circle {
          opacity: 1;
          background: #109cf1;
          background: var(--vortex-blue);
        }
.user__button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 10px 10px 10px;
  border-radius: 5px;
  transition: background-color 0.1s ease;
}
.user__button .dropup {
    line-height: 0;
  }
.user__button:hover .circle {
      background: #706e80;
      background: var(--storm-gray);
    }
.user__button:hover {
  background-color: #efeff0;
  background-color: var(--athens-gray);
}
.user__row {
  display: flex;
  align-items: center;
}
.user__image {
  display: block;
  flex: 0 0 auto;
  width: 36px;
  height: 36px;
  margin-right: 14px;
  border-radius: 50%;
}
.user__name {
  color: #1c1740;
  color: var(--port-gore);
  font-size: 14px;
}
.audiences__search-textbox {
  height: 49px;
  padding-left: 54px;
  border: 0 none;
  border-radius: 5px;
  background-color: rgba(28, 23, 64, 0.04);
  background-color: rgba(var(--port-gore-rgb), 0.04);
  /* background-image: url("/images/magnifier.svg"); */
  background-position: 21px center;
  background-repeat: no-repeat;
  color: #1c1740;
  color: var(--port-gore);
  font-size: 14px;
}
.audiences__item {
  height: 100%;
  padding: 30px 30px 35px 30px;
  border:  1px solid rgb(222, 227, 236);
  background-color: #ffffff;
  background-color: var(--white);
  box-shadow: 0px 2px 4px rgba(28, 23, 64, 0.05);
  border-radius: 5px;
  transition: border-color 0.1s ease, box-shadow 0.1s ease;
  cursor: pointer;
}
.audiences__item:hover {
  border: 2px solid rgba(28, 23, 64, 0.1);
  box-shadow: 0px 2px 4px rgba(28, 23, 64, 0.1);
}
.audiences__item.-dashed-border {
  border: 2px dashed rgba(60, 51, 139, 0.11);
}
.audiences__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 36px;
}
.audiences__counter {
  display: flex;
  align-items: center;
  padding: 15px;
  background: #ffffff;
  background: var(--white);
  border: 1px solid rgba(28, 23, 64, 0.1);
  box-shadow: 0px 2px 4px rgba(28, 23, 64, 0.05);
  border-radius: 5px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
}
.audiences__counter-icon {
  margin-right: 5px;
  color: var(--audiences-item-color);
}
.audiences__title {
  margin-bottom: 12px;
  color: #172b4d;
  color: var(--vortex-deep-blue);
  font-size: 18px;
  font-weight: 700;
  line-height: 21px;
}
.audiences__text {
  color: #706e80;
  color: var(--storm-gray);
  font-size: 14px;
  line-height: 21px;
}
.audience-build {
}
@media screen and (max-width: 768px) {
.audience-build__main #new-audience-btn {
      padding-right: .2em  
  }
    }
@media screen and (max-width: 992px) {
.audience-build__aside {
    margin-top: 2em
}
  }
.audience-build__head {
  display: flex;
  align-items: center;
  min-height: 36px;
  margin-bottom: 10px;
}
.audience-build__title {
  color: #172b4d;
  color: var(--vortex-deep-blue);
  font-size: 18px;
  font-weight: 700;
  line-height: 21px;
}
.audience-build__head-actions {
  display: flex;
  flex: 0 0 auto;
  margin-left: auto;
  padding-left: 10px;
}
.audience-build__head-action {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 36px;
  margin-left: 8px;
  padding: 5px 18px;
  border-radius: 5px;
  background-color: #ffffff;
  background-color: var(--white);
  box-shadow: 0px 2px 4px rgba(28, 23, 64, 0.05);
  color: #fe8663;
  color: var(--vortex-orange);
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  cursor: pointer;
  transition: color 0.1s ease;
}
.audience-build__head-action:hover {
  color: #172b4d;
  color: var(--vortex-deep-blue);
}
.audience-build__head-action:first-child {
  margin-left: 0;
}
.audience-build__head-action-icon {
  margin-right: 10px;
  font-weight: 400;
  opacity: 0.8;
  transition: opacity 0.1s ease;
}
.audience-build__head-action:hover .audience-build__head-action-icon {
  opacity: 1;
}
.audience-build-modal {
}
.audience-build-modal__item {
  display: flex;
  position: relative;
  padding: 28px 30px;
  background: #ffffff;
  background: var(--white);
  border-radius: 5px;
  box-shadow: 0px 2px 4px rgba(28, 23, 64, 0.05);
  border: 2px solid transparent;
  transition: border 0.2s;
}
.audience-build-modal__item.active {
    border: 2px solid var(--orange);
  }
.audience-build-modal__item--hover-select:hover, .audience-build-modal__item--hover-select:focus {
      border: 2px solid var(--orange);
      cursor: pointer;
    }
.audience-build-modal__icon {
  margin-right: 30px;
}
.audience-build-modal__content {
  flex: 1 1 auto;
}
.audience-build-modal__title {
  margin-bottom: 10px;
  color: #172b4d;
  color: var(--vortex-deep-blue);
  font-size: 18px;
  font-weight: 700;
  line-height: 21px;
}
.audience-build-modal__description {
  margin-bottom: 35px;
  color: #706e80;
  color: var(--storm-gray);
  font-size: 14px;
  line-height: 17px;
}
.audience-build-modal__infobox {
  padding: 8px 18px;
  border: 1px solid rgba(28, 23, 64, 0.1);
  border: 1px solid rgba(var(--port-gore-rgb), 0.1);
  border-radius: 5px;
  box-shadow: 0px 2px 4px rgba(28, 23, 64, 0.05);
  box-shadow: 0px 2px 4px rgba(var(--port-gore-rgb), 0.05);
}
.audience-build-modal__infobox .form-control {
    padding: 0;
    display: flex;
    height: auto;
    border: 0;
  }
.audience-build-modal__infobox .form-group {
    margin: 0;
  }
.audience-build-modal__infobox-name {
  color: #706e80;
  color: var(--storm-gray);
  font-size: 12px;
  font-weight: 700;
  line-height: 12px;
}
.audience-build-modal__infobox-content {
  color: #172b4d;
  color: var(--vortex-deep-blue);
  font-size: 14px;
  line-height: 17px;
}
.audience-build-modal__decisive-buttons .btn {
  min-width: 198px;
}
.audience-build-modal__cancel {
  color: #706e80;
  color: var(--storm-gray);
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  cursor: pointer;
}
.audience-build-modal__cancel:hover {
  -webkit-text-decoration: underline;
  text-decoration: underline;
}
.audience-build-modal__select-control a:hover {
  -webkit-text-decoration: underline;
  text-decoration: underline;
}
.filter-body .select2-container {
      width: 100% !important;
    }
@media screen and (max-width: 768px) {
.filter-body {
      display: flex;
      flex-direction: column !important
  }
    }
@media screen and (max-width: 768px) {
.filter {
    display: flex;
    flex-direction: column !important;
    align-items: flex-start !important
}

    .filter [class^="col"], .filter [class*=" col"] {
      width: 100% !important;
      max-width: 100% !important;
      flex: 1 !important;
      display: block;
      margin-bottom: 1em;
      padding: 0 1em !important;
    }
  }
.audience-create-filters {
  border-radius: 5px;
  background: #ffffff;
  background: var(--white);
}
/*box-shadow: 0px 2px 4px rgba(28, 23, 64, 0.05);*/
/*border: 2px solid rgb(222, 227, 236);*/
.audience-create-filters__item {
    border: 1px solid rgba(28, 23, 64, 0.1);
    border: 1px solid rgba(var(--port-gore-rgb), 0.1);
    box-sizing: border-box;
    box-shadow: 0px 2px 4px rgba(28, 23, 64, 0.05);
    box-shadow: 0px 2px 4px rgba(var(--port-gore-rgb), 0.05);
    border-radius: 5px;
    color: #1c1740;
    color: var(--port-gore);
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    padding: 1em 1.2em;
    margin: .5em;
  }
.audience-create-filters__item.-muted {
      background: #f4f4f7;
      background: var(--light-sky-gray);
      box-shadow: none;
      border: none;
    }
.audience-create-filters__section {
  position: relative;
  padding: 30px;
  border-bottom: 1px solid rgba(23, 43, 77, 0.07);
  border-bottom: 1px solid rgba(var(--vortex-deep-blue-rgb), 0.07);
  color: #706e80;
  color: var(--storm-gray);
  font-size: 14px;
}
.audience-create-filters:last-child {
  border-bottom: 0 none;
}
.audience-create-filters__section::after {
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 0 30px;
  transform: translateY(50%);
  background-color: #ffffff;
  background-color: var(--white);
  color: rgba(112, 110, 128, 0.5);
  color: rgba(var(--storm-gray-rgb), 0.5);
  font-size: 12px;
  font-weight: 700;
  line-height: 14px;
  content: "AND";
}
.audience-create-filters__section:last-child::after {
  display: none;
}
.audience-create-filters__title {
  color: #172b4d;
  color: var(--vortex-deep-blue);
  word-wrap: break-word;
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
}
.audience-create-filters__section input[type="text"] {
  border: 1px solid rgba(28, 23, 64, 0.1);
  border: 1px solid rgba(var(--port-gore-rgb), 0.1);
  box-sizing: border-box;
  box-shadow: 0px 2px 4px rgba(28, 23, 64, 0.05);
  box-shadow: 0px 2px 4px rgba(var(--port-gore-rgb), 0.05);
  border-radius: 5px;
  color: #1c1740;
  color: var(--port-gore);
  font-size: 14px;
  line-height: 17px;
  text-align: center;
}
.audience-create-filters__section select {
  border: 1px solid rgba(28, 23, 64, 0.1);
  border: 1px solid rgba(var(--port-gore-rgb), 0.1);
  box-sizing: border-box;
  box-shadow: 0px 2px 4px rgba(28, 23, 64, 0.05);
  box-shadow: 0px 2px 4px rgba(var(--port-gore-rgb), 0.05);
  border-radius: 5px;
  color: #1c1740;
  color: var(--port-gore);
  font-size: 14px;
  line-height: 17px;
  text-align: center;
}
.audience-exports {
  border-radius: 8px;
  background: #ffffff;
  background: var(--white);
  border: 2px solid rgb(222, 227, 236);
  overflow-x: scroll;
  display: flex;
}
.audience-exports__table {
  color: #172b4d;
  color: var(--vortex-deep-blue);
  font-size: 14px;
  line-height: 17px;
}
.audience-exports__table th {
  color: #706e80;
  color: var(--storm-gray);
  font-size: 12px;
  font-weight: 700;
  line-height: 14px;
  vertical-align: middle;
}
.audience-exports__table td {
  vertical-align: middle;
  word-wrap: break-word;
  -webkit-hyphens: auto;
          hyphens: auto;
  max-width: 270px;
}
.audience-exports__table-icon {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  color: var(--audience-exports-icon-color);
  font-size: 18px;
}
.audience-exports__table-icon-image {
  display: block;
  width: 18px;
  height: auto;
}
.audience-exports__table-icon::after {
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: 50%;
  background-color: var(--audience-exports-icon-color);
  opacity: 0.1;
  content: "";
}
#task-owner-checkbox {
  display: none;
}
#opportunity-owner {
  display: none
}
#lead-source-for-new-opportunity {
  display: none;
}
#lead-source-for-new-lead {
  display: none;
}
.dynamics-activity-type {
  display: none
}
.audience-build__aside {
 position: sticky; 
 top: 25px;
}
.audience-report {
  border-radius: 5px;
  background-color: #ffffff;
  background-color: var(--white);
  box-shadow: 0px 2px 4px rgba(28, 23, 64, 0.05);
}
.audience-report__section {
  padding: 30px;
  border-bottom: 1px solid rgba(23, 43, 77, 0.07);
  border-bottom: 1px solid rgba(var(--vortex-deep-blue-rgb), 0.07);
}
.audience-report__section:last-child {
  border-bottom: 0 none;
}
.audience-report__icon {
  color: rgba(23, 43, 77, 0.5);
  color: rgba(var(--vortex-deep-blue-rgb), 0.5);
  font-size: 15px;
}
.audience-report__number {
  color: #1c1740;
  color: var(--port-gore);
  font-size: 24px;
  line-height: 29px;
}
.audience-report__number-label {
  display: flex;
  align-items: center;
  margin-top: 3px;
  color: #706e80;
  color: var(--storm-gray);
  font-size: 12px;
  font-weight: 700;
}
.audience-report__percent {
  margin-left: 5px;
  padding: 3px 6px;
  border: 1px solid rgba(28, 23, 64, 0.1);
  border: 1px solid rgba(var(--port-gore-rgb), 0.1);
  box-sizing: border-box;
  border-radius: 5px;
  box-shadow: 0px 2px 4px rgba(28, 23, 64, 0.05);
  box-shadow: 0px 2px 4px rgba(var(--port-gore-rgb), 0.05);
  color: #706e80;
  color: var(--storm-gray);
  font-size: 12px;
  font-weight: 700;
  line-height: 14px;
}
.audience-report__percent.-orange {
  color: #fe8663;
  color: var(--vortex-orange);
}
.aside-navigation__label {
  font-family: "Work Sans",apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
  font-size: 14px;
  font-weight: 500;
  margin-top: 24px;
  display: block;
  display: var(--fly-nav-label-display,block);
  color: #634960;
}
.aside-navigation__separator {
  border: 0;
  height: 1px;
  background-color: #f0f1f3;
}
.aside-navigation__list {
  margin: 0;
  padding: 0 1rem;
  list-style: none;
  width: 100%;
}
.aside-navigation__list li:first-of-type {
  padding: 12px 0 0;
}
.aside-navigation__list li:last-of-type {
}
.aside-navigation__link {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  padding: 12.25px 14px;
  border-radius: 6px;
  transition: color 0.1s ease;
  color: #4f4c58;
  font-size: 16px;
  font-weight: normal;
  font-family: Rubik,apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;
  box-sizing: border-box;
}
.aside-navigation__link:hover {
  background-color: rgba(28, 23, 64, 0.05);
  background-color: rgba(var(--port-gore-rgb), 0.05);
  color: rgba(28, 23, 64, 0.8);
  color: rgba(var(--port-gore-rgb), 0.8);
}
.aside-navigation__link.-active {
  color: #1d2637;
  background-color: #eff5ff;
}
.aside-navigation__icon {
  position: relative;
  margin-right: 12px;
  font-size: 1.25rem;
}
.aside-navigation__link.-active .aside-navigation__icon {
  color: rgb(56, 105, 199);
  color: var(--fly-color-primary, rgb(56, 105, 199));
}
.aside-navigation__link.-notify-dot .aside-navigation__icon::after {
  display: block;
  position: absolute;
  top: -4px;
  left: 9px;
  width: 12px;
  height: 12px;
  border: 2px solid #ffffff;
  border: 2px solid var(--white);
  border-radius: 50%;
  background-color: #172b4d;
  background-color: var(--vortex-deep-blue);
  content: "";
}
.beta-badge {
  color: white;
  background: rgb(56, 105, 199);
  background: var(--fly-color-primary, rgb(56, 105, 199));
  font-size: 12px;
  padding: 3px 8px;
  border-radius: 6px;
  margin-left: 12px;
  font-style: normal;
  font-weight: normal;
  font-family: Rubik, apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  box-sizing: border-box;
}
.navbar-collapse {
  flex-direction: column;
}
.content-head {
  display: flex;
  align-items: flex-start;
  padding: 55px 0 30px;
  margin-bottom: 40px;
  border-bottom: 1px solid rgba(28, 23, 64, 0.07);
}
@media screen and (max-width: 576px) {
.content-head {
    flex-direction: column
}

    .content-head > div {
      margin-bottom: 1em;
    }
  }
@media screen and (max-width: 768px) {
.content-head#audience-build-content-head {
      flex-direction: column
  }
    }
.content-head #audience-header {
    width: 100%;
    align-items: flex-start;
  }
@media screen and (max-width: 768px) {
.content-head #audience-header {
      align-items: center;
      margin-top: 2em
  }
    }
@media screen and (max-width: 576px) {
.content-head #audience-header {
      flex-direction: column;
      align-items: flex-start
  }
    }
.content-head #audience-submit-button {
    margin-top: 1em;
  }
@media screen and (min-width: 576px) {
.content-head #audience-submit-button {
      margin-top: 0;
      margin-left: 1em
  }
    }
.content-head__back {
  flex: 0 0 auto;
  margin-right: 30px;
}
.content-head__icon {
  margin-right: 20px;
}
@media screen and (max-width: 576px) {
.content-head__icon {
    display: none !important
}
  }
.content-head__text {
  flex: 1 1 auto;
  overflow: hidden;
}
.content-head__text .form-control {
    border-color: rgba(0, 0, 0, 0.09);
    max-width: 75% !important;
    min-width: 400px !important;
  }
.content-head__text form {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
.content-head__title {
  color: #172b4d !important;
  color: var(--vortex-deep-blue) !important;
  font-size: 24px;
  font-weight: 700;
}
.content-head__title::-moz-placeholder {
    color: #172b4d !important;
    color: var(--vortex-deep-blue) !important;
    opacity: .5;
  }
.content-head__title::placeholder {
    color: #172b4d !important;
    color: var(--vortex-deep-blue) !important;
    opacity: .5;
  }
.content-head__title.form-control {
    width: auto;
    height: auto;
    background: transparent;
    border-radius: 0;
    padding: 0;
    border-top: 0;
    border-left: 0;
    border-right: 0;
    border-width: 2px;
    margin-bottom: .15em;
  }
.content-head__title.form-control:focus {
      border-color: var(--orange);
    }
.content-head__subtitle {
  color: var(--vortex-storm-gray);
  font-size: 14px;
}
.content-head__subtitle.form-control {
    width: auto;
    height: auto;
    background: transparent;
    border-radius: 0;
    padding: 0;
    border-top: 0;
    border-left: 0;
    border-right: 0;
    border-width: 2px;
    padding-bottom: .25em;
  }
.content-head__subtitle.form-control:focus {
      border-color: var(--orange);
    }
.connections-destinations {
}
.connections-destinations__item {
  display: flex;
  position: relative;
  padding: 30px 80px 30px 36px;
}
@media screen and (max-width: 768px) {
.connections-destinations__item {
    flex-direction: column
}
  }
.connections-destinations__options-button {
  position: absolute;
  top: 30px;
  right: 35px;
}
.connections-destinations__icon {
  margin-right: 70px;
}
@media screen and (max-width: 768px) {
.connections-destinations__icon {
    margin-bottom: 2em
}
  }
.connections-destinations__content {
  flex: 1 1 auto;
}
.connections-destinations__title {
  margin-bottom: 10px;
  color: #172b4d;
  color: var(--vortex-deep-blue);
  font-size: 18px;
  font-weight: 700;
  line-height: 21px;
}
.connections-destinations__description {
  margin-bottom: 35px;
  color: #706e80;
  color: var(--storm-gray);
  font-size: 14px;
  line-height: 17px;
}
.connections-destinations__info {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  color: #706e80;
  color: var(--storm-gray);
  font-size: 14px;
  line-height: 21px;
}
.connections-destinations__info-date {
  color: #1c1740;
  color: var(--port-gore);
  font-weight: 700;
}
.connections-destinations__info-icon {
  margin-left: 5px;
  color: #1fa463;
  color: var(--vortex-green);
  font-size: 15px;
}
.connections-destinations__entry {
  padding-bottom: 15px;
  margin-bottom: 15px;
  border-bottom: 1px solid rgba(23, 43, 77, 0.07);
  border-bottom: 1px solid rgba(var(--vortex-deep-blue-rgb), 0.07);
}
.connections-destinations__entry:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: 0 none;
}
.connections-destinations__entry-name {
  color: #706e80;
  color: var(--storm-gray);
  font-size: 14px;
  line-height: 17px;
}
.connections-destinations__entry-value {
  color: #172b4d;
  color: var(--vortex-deep-blue);
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
}
.connections-sources__edit-fields {
    padding: 1.5rem;
  }
.connections-sources__edit-fields input[type="text"], .connections-sources__edit-fields textarea, .connections-sources__edit-fields select {
      border: 1px solid rgba(28, 23, 64, 0.1);
      border: 1px solid rgba(var(--port-gore-rgb), 0.1);
      box-sizing: border-box;
      box-shadow: 0px 2px 4px rgba(28, 23, 64, 0.05);
      box-shadow: 0px 2px 4px rgba(var(--port-gore-rgb), 0.05);
      border-radius: 5px;
      color: #1c1740;
      color: var(--port-gore);
      font-size: 14px;
      line-height: 17px;
    }
.connections-sources__item {
  display: flex;
  position: relative;
  padding: 30px 80px 30px 36px;
  background: #ffffff;
  background: var(--white);
  border-radius: 5px;
  box-shadow: 0px 2px 4px rgba(28, 23, 64, 0.05);
}
@media screen and (max-width: 768px) {
.connections-sources__item {
    flex-direction: column;
    margin-bottom: 2em
}
  }
.connections-sources__options-button {
  position: absolute;
  top: 30px;
  right: 35px;
}
.connections-sources__icon {
  margin-right: 70px;
}
@media screen and (max-width: 768px) {
.connections-sources__icon {
    margin-bottom: 2em
}
  }
.connections-sources__content {
  position: relative;
  flex: 1 1 auto;
}
.connections-sources__content::after {
  display: block;
  position: absolute;
  right: 0;
  bottom: 15px;
  left: 0;
  height: 1px;
  background-color: #ffffff;
  background-color: var(--white);
  content: "";
}
.connections-sources__title {
  margin-bottom: 25px;
  color: #172b4d;
  color: var(--vortex-deep-blue);
  font-size: 18px;
  font-weight: 700;
  line-height: 21px;
}
.connections-sources__entry {
  padding-bottom: 15px;
  padding-right: 2em;
  margin-bottom: 15px;
  border-bottom: 1px solid rgba(23, 43, 77, 0.07);
  border-bottom: 1px solid rgba(var(--vortex-deep-blue-rgb), 0.07);
}
.connections-sources__entry-name {
  color: #706e80;
  color: var(--storm-gray);
  font-size: 14px;
  line-height: 17px;
}
.connections-sources__entry-value {
  color: #172b4d;
  color: var(--vortex-deep-blue);
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
}
.icon-item {
  display: flex;
  position: relative;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: var(--icon-item-background);
  color: var(--icon-item-color);
  font-size: 24px;
}
.icon-item.-big {
  width: 84px;
  height: 84px;
  font-size: 30px;
}
.icon-item.-small {
  width: 48px;
  height: 48px;
  font-size: 18px;
}
.icon-item.-xsmall {
  width: 30px;
  height: 30px;
  font-size: 16px;
}
.icon-item.-shadow {
  box-shadow: 0px 2px 4px rgba(28, 23, 64, 0.05);
}
.icon-item__image {
  display: block;
  width: 30px;
  height: auto;
}
.icon-item.-big .icon-item__image {
  width: 36px;
}
.icon-item.-small .icon-item__image {
  width: 18px;
}
.icon-item.-xsmall .icon-item__image {
  width: 16px;
}
.icon-item__check {
  position: absolute;
  right: -4px;
  bottom: -4px;
  border: 4px solid #efeff0;
  border: 4px solid var(--athens-gray);
  border-radius: 50%;
  background-color: #ffffff;
  background-color: var(--white);
  color: #1fa463;
  color: var(--vortex-green);
  font-size: 16px;
  line-height: 16px;
  cursor: pointer;
}
.logo {
  display: block;
  padding: 24px 15px 12px;
}
.logo__image {
  display: block;
  max-width: 100%;
  height: auto;
  margin: 0 auto;
}
.percent-change {
  font-size: 12px;
  font-weight: 700;
  line-height: 14px;
}
.percent-change.-green {
  color: #1fa463;
  color: var(--vortex-green);
}
.percent-change.-red {
  color: #ff5c5c;
  color: var(--vortex-red);
}
.percent-change__icon {
  margin-right: 3px;
  font-size: 8px;
}
.main-content {
  background-color: #efeff0;
  background-color: var(--athens-gray);
  flex: 1;
}
@media (min-width: 992px) {
  .main-content {
    padding: 0 30px;
  }
}
.section-body {
  border-radius: 5px;
  background: #ffffff;
  background: var(--white);
}
.outlined-section-body {
  @extend .section-body;
  border-radius: 5px;
  border: 2px solid rgb(222, 227, 236);
}
.section-head {
  display: flex;
  align-items: center;
  min-height: 39px;
  margin-bottom: 10px;
}
.section-head__title {
  color: #172b4d;
  color: var(--vortex-deep-blue);
  font-size: 18px;
  font-weight: 700;
  line-height: 21px;
}
.section-head__sync {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  margin-left: auto;
  padding-left: 10px;
  font-size: 12px;
}
.section-head__actions {
  display: flex;
  flex: 0 0 auto;
  margin-left: auto;
  padding-left: 10px;
}
.section-head__action {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 36px;
  margin-left: 8px;
  padding: 5px 18px;
  border-radius: 5px;
  background-color: #ffffff;
  background-color: var(--white);
  box-shadow: 0px 2px 4px rgba(28, 23, 64, 0.05);
  color: #fe8663;
  color: var(--vortex-orange);
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  cursor: pointer;
  transition: color 0.1s ease;
}
.section-head__action:hover {
  color: #172b4d;
  color: var(--vortex-deep-blue);
}
.section-head__action:first-child {
  margin-left: 0;
}
.section-head__action-icon {
  margin-right: 10px;
  font-weight: 400;
  opacity: 0.8;
  transition: opacity 0.1s ease;
}
.section-head__action:hover .section-head__action-icon {
  opacity: 1;
}
.table {
  font-size: 10px;
}
.table .list a:hover {
      color: #706e80;
      color: var(--storm-gray);
    }
.table .select2-container {
    width: 100% !important;
  }
@media screen and (max-width: 768px) {
.table .user__info {
      display: none !important
  }
    }
@media (min-width: 1200px) {
  .table {
    font-size: 12px;
  }
}
.table__label {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  min-height: 40px;
  padding: 5px;
  border-radius: 5px;
  color: #ffffff;
  color: var(--white);
  font-size: 10px;
  font-weight: 700;
  line-height: 14px;
}
@media (min-width: 992px) {
  .table__label {
    min-width: 90px;
    font-size: 12px;
  }
}
@media (min-width: 1200px) {
  .table__label {
    min-width: 102px;
  }
}
.table__label.-blue {
  background-color: #109cf1;
  background-color: var(--vortex-blue);
}
.table__label.-dark {
  background-color: #1c1740;
  background-color: var(--port-gore);
}
.table__label.-deep-blue {
  background-color: #172b4d;
  background-color: var(--vortex-deep-blue);
}
.table__label.-gray {
  background-color: #706e80;
  background-color: var(--storm-gray);
}
.table__label.-green {
  background-color: #1fa463;
  background-color: var(--vortex-green);
}
.table__label.-light {
  background-color: #efeff0;
  background-color: var(--athens-gray);
}
.table__label.-orange {
  background-color: #fe8663;
  background-color: var(--vortex-orange);
}
.table__label.-red {
  background-color: #ff5c5c;
  background-color: var(--vortex-red);
}
.tabs-nav {
}
.tabs-nav__item {
  padding: 18px 5px;
  border-bottom: 2px solid transparent;
  color: #706e80;
  color: var(--storm-gray);
  font-size: 14px;
  line-height: 17px;
  font-weight: 600;
  text-align: center;
  transition: color 0.1s ease, border-color 0.1s ease;
}
.tabs-nav__item:hover {
  color: rgba(28, 23, 64, 0.8);
  color: rgba(var(--port-gore-rgb), 0.8);
}
.tabs-nav__item.active {
  color: #172b4d;
  color: var(--vortex-deep-blue);
  border-bottom-color: #172b4d;
  border-bottom-color: var(--vortex-deep-blue);
}
.tabs-nav__item-icon {
  margin-right: 15px;
  font-size: 20px;
}
.true-false-toggle {
  width: 100%;
  display: flex;
  padding: 6px;
  border-radius: 5px;
  background-color: rgba(112, 110, 128, 0.07);
  background-color: rgba(var(--storm-gray-rgb), 0.07);
}
.true-false-toggle .btn {
  box-shadow: 0px 2px 4px rgba(28, 23, 64, 0);
  border-radius: 5px;
  color: #706e80;
  color: var(--storm-gray);
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  cursor: pointer;
}
.true-false-toggle .btn:not(.active):hover {
  background-color: rgba(23, 43, 77, 0.05);
  background-color: rgba(var(--vortex-deep-blue-rgb), 0.05);
}
.true-false-toggle .btn.active {
  background: #ffffff;
  box-shadow: 0px 2px 4px rgba(28, 23, 64, 0.05);
  color: #172b4d;
  color: var(--vortex-deep-blue);
}
/* Structure & Layout */
#wrapper {
    flex-direction: column;
}
@media (min-width: 992px) {
#wrapper {
        flex-direction: row
}
    }
#sidebar {
    width: 100%;
    top: 0;
    width: 100%;
    z-index: 2;
}
#sidebar .logo {
        display: flex;
        justify-content: center;
    }
@media (min-width: 992px) {
#sidebar {
        max-width: 280px;
        position: sticky;
        left: 0
}

        #sidebar .logo {
            display: block;
        }
    }
.navbar {
  padding: 0 !important;
}
.main-content {
    padding: 0 1rem 2.5rem;
}
/*
 .page-wrapper {
  width: 100%;
}

.audience-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 30px;
  margin-top: 20px;
  margin-bottom: 50px;
}
*/
/* Elements */
.section__edit-fields {
    padding: 1.5rem;
  }
.section__edit-fields input[type="text"], .section__edit-fields textarea, .section__edit-fields select {
      border: 1px solid rgba(28, 23, 64, 0.1);
      border: 1px solid rgba(var(--port-gore-rgb), 0.1);
      box-sizing: border-box;
      box-shadow: 0px 2px 4px rgba(28, 23, 64, 0.05);
      box-shadow: 0px 2px 4px rgba(var(--port-gore-rgb), 0.05);
      border-radius: 5px;
      color: #1c1740;
      color: var(--port-gore);
      font-size: 14px;
      line-height: 17px;
    }
.spinner-double,
.spinner-double:after {
  border-radius: 50%;
  width: 10em;
  height: 10em;
}
.spinner-double {
  margin: 0 1em;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 1.1em solid rgba(255, 255, 255, 0.2);
  border-right: 1.1em solid rgba(255, 255, 255, 0.2);
  border-bottom: 1.1em solid rgba(255, 255, 255, 0.2);
  border-left: 1.1em solid #ffffff;
  transform: translateZ(0);
  animation: load8 1.1s infinite linear;
}
@keyframes load8 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/* Pages */
.match-fields {
  font-size: 0.8rem;
}
.match-field {
  margin-left: 3em;
  display: flex;
  align-items: center;
}
.match-field-label {
    color: #706e80;
    color: var(--storm-gray);
    font-weight: bold;
  }
.match-field svg {
    margin-left: 0.5em;
  }
.match-field-value {
    background: #efeff0;
    background: var(--athens-gray);
    color: #999;
    font-size: 0.9em;
    margin-left: 1em;
    padding: 0.7em 1em;
    border-radius: 3px;
  }
.onboarding__header {
    border-bottom: 1px solid #e1e1e3;
  }
.onboarding__headline {
    font-size: 48px;
    color: #172b4d;
    color: var(--vortex-deep-blue);
  }
.onboarding__subline {
    font-size: 21px;
    color: #706e80;
    color: var(--storm-gray);
  }
.onboarding__divider {
    width: 45px;
    height: 3px;
    background-color: #b8b8c4;
    border: 0;
    margin: 2em 0 3em;
  }
.onboarding__segmentation {
    padding: 0;
    overflow: hidden;
    position: relative;
    min-height: 740px;
  }
.onboarding__segmentation__overlay {
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 2;
      background: rgba(33, 33, 55, 0.45);
    }
.onboarding__segmentation__bg {
      position: absolute;
      top: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      background-image: url('/assets/onboarding__bg.png');
      background-repeat: no-repeat;
      background-size: cover;
      background-position: top;
      /* Add the blur effect */
      filter: blur(8px);
      -webkit-filter: blur(8px);
    }
.onboarding__segmentation__box {
      display: flex;
      flex-direction: column;
      align-items: center;
      z-index: 3;
      position: absolute;
      width: 80%;
      left: 10%;
      top: 100px;
      padding: 3rem 2rem 2.5rem;
      background: white;
      border-radius: 8px;
      box-shadow: 0 4px 18px rgba(0, 0, 0, 0.1);
    }
.onboarding__segmentation__box img {
        width: 80%;
      }
.onboarding__segmentation__box header {
        display: flex;
        align-items: center;
        justify-content: center;
      }
.onboarding__segmentation__box header h2 {
          margin-left: 2rem;
          margin-top: -10px;
        }
.onboarding-btn {
    font-size: 1.2rem;
    padding: 1em 1.5em;
    width: 95%;
  }
.onboarding-btn.selected {
      color: #fff;
      background-color: #343a40;
      border-color: #343a40;
    }
.onboarding-btn.selected:before {
        position: absolute;
        top: -1px;
        right: -1px;
        bottom: -1px;
        left: -1px;
        border-radius: 5px;
        background-color: #000;
        opacity: 0;
        content: "";
        z-index: -1;
        transition: opacity 0.15s ease-in-out;
      }
.onboarding-btn img {
      max-height: 36px !important;
      margin-right: 24px !important;
      display: inline-block;
    }
.onboarding-btn.disabled {
      opacity: 0.6;
      background-color: white !important;
      transition: none;
    }
.onboarding-btn.disabled:hover, .onboarding-btn.disabled:focus-within, .onboarding-btn.disabled:focus {
        color: #343a40;
        border-color: rgba(112, 110, 128, 0.1);
        box-shadow: none;
        background-color: white !important;
      }
.onboarding-btn.disabled:hover:before, .onboarding-btn.disabled:hover::before, .onboarding-btn.disabled:focus-within:before, .onboarding-btn.disabled:focus-within::before, .onboarding-btn.disabled:focus:before, .onboarding-btn.disabled:focus::before {
          transition: none;
          background-color: white !important;
          display: none;
        }
.onboarding-setup-btn {
    display: flex;
    align-items: center;
    padding: 1em 1.2em;
    border: 1px solid #ccc;
    color: #172b4d;
    color: var(--vortex-deep-blue);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);

  }
.onboarding-setup-btn .spinner-double {
      font-size: 2px !important;
      margin-left: 42px;
    }
.onboarding-setup-btn:hover, .onboarding-setup-btn.sending {
      background: #343a40;
      color: white;
      border-color: transparent;
    }
.onboarding-setup-btn:disabled {
      box-shadow: none;
      color: var(--secondary);
      opacity: 0.7;
      cursor: default;
      background: white;
    }
.onboarding-setup-btn:disabled:hover {
        box-shadow: none;
        color: var(--secondary);
        opacity: 0.8;
        cursor: default;
        border-color: #e9e9e9;
        background: white;
      }
.onboarding-setup-btn:disabled:hover:before {
          display: none;
        }
.onboarding-setup-btn .icon-arrow-right4 {
      margin: 0 0 0 3rem !important;
      font-size: 1rem;
      display: inline-flex;
    }
.onboarding__buttons {
    padding: 0 2rem;
    width: 100%;
    display: grid;
    grid-template-rows: 1fr 1fr;
    grid-template-columns: 1fr 1fr;
    grid-gap: 12x;
  }
.onboarding__buttons-footer {
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }
/* Misc */
.loader {
  display: none;
}
/* Includes */
.include {
  padding: .5em;
  display: flex;
  flex-direction: column;
}
.include__header {
  display: flex;
  justify-content: space-between;
}
.include__data {
  line-height: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: .95rem;
}
.include__data > div {
  word-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  -webkit-hyphens: auto;
  hyphens: auto;
}
.include__type {
  font-size: 9px;
  text-transform: capitalize;
  padding: .6em 1em;
  border-radius: 4px;
  background-color: #babfc5;
  color: var(--body-color);
  font-weight: bold;
  height: 25px;
}
.include__table {
  font-size: .8rem;
  font-weight: bold;
  opacity: 0.35;
  margin-top: .4em;
}
.include__description{
  font-size: .8rem;
  font-weight: bold;
   opacity: 0.35;
}
.muted-link {
  -webkit-text-decoration: none !important;
  text-decoration: none !important;
  color: grey !important;
  cursor: none !important;
}
#audienceBuildAddFilterModal .select2-search--hide{
  display: block !important;
}
#audienceBuildAddFilterModal .select2-dropdown.select2-dropdown--below{
  height: 300px;
}
/*
.tp-tooltip {
  position: fixed;
  display: flex;
  flex-direction: column;
  visibility: var(--tp-tooltip-content-visibility) !important;
  z-index: 999;
  text-transform: none;
  color: rgba(0, 0, 0, 0.56);
  background-color: #fff;
  padding: 10px;
  left: var(--tp-tooltip-content-x-position);
  top: var(--tp-tooltip-content-y-position);
  width: var(--tp-tooltip-content-width) !important;
  font: 400 12px/16px Roboto, HelveticaNeue, Arial, sans-serif;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(60, 64, 67, 0.05),
    0 4px 8px 3px rgba(60, 64, 67, 0.15);
}

.tp-tooltip::after {
  content: '';
  z-index: 999;
  visibility: var(--tp-tooltip-anchor-pointer-display-bottom);
  border-width: 8px;
  position: absolute;
  left: var(--tp-tooltip-anchor-pointer-x-position);
  top: var(--tp-tooltip-anchor-pointer-y-position);
  border-style: solid;
  border-color: #fff transparent transparent transparent;
}

.tp-tooltip::before {
  content: '';
  z-index: 999;
  visibility: var(--tp-tooltip-anchor-pointer-display-top);
  border-width: 8px;
  position: absolute;
  left: var(--tp-tooltip-anchor-pointer-x-position);
  bottom: var(--tp-tooltip-anchor-pointer-y-position);
  border-style: solid;
  border-color: transparent transparent #fff transparent;
}
}*/
/* Forms */
.form-group p {
    font-size: 0.85rem;
  }
.select2-selection__choice {
    background: white !important;
    border-color: #eee !important;
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.08);
    padding: .2em .8em !important;
  }
.select2-container--default.select2-container--focus .select2-selection--multiple {
        border-color: #109cf1 !important;
        border-color: var(--vortex-blue) !important;
      }
/* Loader */
.load > *, .loading > * {
    display: none;
  }
.load .loader, .loading .loader {
    display: block;
  }
.loaded > * {
    display: inline;
    display: initial;
  }
.loaded .loader {
    display: none;
  }
/* Utils */
.line-wrap {
  word-wrap: break-word;
  word-wrap: break-word;
  -ms-word-break: break-all;
  word-break: break-all;
  word-break: break-word;
  -webkit-hyphens: auto;
  hyphens: auto;
}
`, "",{"version":3,"sources":["webpack://./v1/src/stylesheets/main.css","webpack://./v1/src/stylesheets/components/variables.css","webpack://./v1/src/stylesheets/partials/variables.css","webpack://./v1/src/stylesheets/components/typography.css","webpack://./v1/src/stylesheets/components/aside.css","webpack://./v1/src/stylesheets/components/buttons.css","webpack://./v1/src/stylesheets/components/user.css","webpack://./v1/src/stylesheets/components/audiences.css","webpack://./v1/src/stylesheets/components/audience-build.css","webpack://./v1/src/stylesheets/components/audience-build-modal.css","webpack://./v1/src/stylesheets/components/audience-create-filters.css","webpack://./v1/src/stylesheets/components/audience-exports.css","webpack://./v1/src/stylesheets/components/audience-report.css","webpack://./v1/src/stylesheets/components/aside-navigation.css","webpack://./v1/src/stylesheets/components/content-head.css","webpack://./v1/src/stylesheets/components/connections-destinations.css","webpack://./v1/src/stylesheets/components/connections-sources.css","webpack://./v1/src/stylesheets/components/icon-item.css","webpack://./v1/src/stylesheets/components/logo.css","webpack://./v1/src/stylesheets/components/percent-change.css","webpack://./v1/src/stylesheets/components/main-content.css","webpack://./v1/src/stylesheets/components/section-body.css","webpack://./v1/src/stylesheets/components/section-head.css","webpack://./v1/src/stylesheets/components/table.css","webpack://./v1/src/stylesheets/components/tabs-nav.css","webpack://./v1/src/stylesheets/components/true-false-toggle.css","webpack://./v1/src/stylesheets/partials/layout.css","webpack://./v1/src/stylesheets/partials/section.css","webpack://./v1/src/stylesheets/partials/animations.css","webpack://./v1/src/stylesheets/partials/pages/signal-routing.css","webpack://./v1/src/stylesheets/partials/pages/onboarding.css","webpack://./v1/src/stylesheets/partials/misc.css","webpack://./v1/src/stylesheets/partials/forms.css","webpack://./v1/src/stylesheets/partials/loader.css","webpack://./v1/src/stylesheets/partials/utils.css"],"names":[],"mappings":"AAAA,cAAW;ACAX;EACE,sBAAsB;EACtB,gCAAgC;EAChC,yBAAyB;EACzB,mCAAmC;EACnC,oBAAoB;EACpB,2BAA2B;EAC3B,qBAAqB;EACrB,+BAA+B;EAC/B,sBAAsB;EACtB,+BAA+B;EAC/B,2BAA2B;EAC3B,kCAAkC;EAClC,uBAAuB;EACvB,+BAA+B;EAC/B,wBAAwB;EACxB,iCAAiC;EACjC,qBAAqB;EACrB,6BAA6B;EAC7B,gBAAgB;EAChB,0BAA0B;AAC5B;ACrBA,qBAAkB;AFIlB,aAAU;AGJV;EACE,cAAuB;EAAvB,uBAAuB;AACzB;AAEA;EACE,cAAc;AAChB;AAEA;EACE,cAAc;EACd,6BAAqB;EAArB,qBAAqB;AACvB;ACXA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,yBAA8B;EAA9B,8BAA8B;EAC9B,+BAA+B;AACjC;AAEA;EACE;IACE,gBAAgB;IAChB,aAAa;IACb,MAAM;IACN,gBAAgB;EAClB;AACF;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;ACzBA;EACE,cAAc;EACd,6BAA6B;EAC7B,4BAA6C;EAA7C,6CAA6C;EAC7C,2BAA2B;EAC3B,eAAe;AACjB;AAEA;EACE,0BAA2C;EAA3C,2CAA2C;AAC7C;AAEA;EACE,aAAa;AACf;AAEA;EACE,cAAuB;EAAvB,uBAAuB;EACvB,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,eAAe;AACjB;AAEA;EACE,YAAY;AACd;AAGA;EACE,oCAAoC;EACpC,8CAA8C;EAC9C,0CAA0C;AAC5C;AAEA;EACE,oCAAoC;AACtC;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;AAClC;ACxDA;EACE,aAAa;EACb,mBAAmB;AAwIrB;AAtIE;IACE,mBAAmB;IACnB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,+BAA+B;IAC/B,iBAAiB;IACjB,eAAe;EACjB;AAEA;IACE,iBAAiB;EA4DnB;AAzDI;AADF;QAEI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB;IAEJ;MADE;AAGF;MACE,aAAa;IACf;AAEA;MACE,aAAa;MACb,sBAAsB;MACtB,uBAAuB;MACvB,mBAAmB;MACnB,gBAAgB;IAOlB;AALE;AAPF;QAQI,2BAA2B;QAC3B,uBAAuB;QACvB;IAEJ;MADE;AAGF;MACE,aAAa;MACb,+CAAgE;MAAhE,gEAAgE;IAClE;AAEA;MACE,WAAW;MACX,oBAAoB;MACpB,SAAS;MACT,kBAAkB;MAClB,kBAAkB;IAoBpB;AAlBE;QACE,kBAAkB;QAClB,aAAa;QACb,WAAW;QACX,YAAY;QACZ,uBAAuB;QACvB,mBAAmB;QACnB,eAAe;QACf,MAAM;MACR;AAEA;AAlBF;QAmBI;IAMJ;MALE;AAEA;AAtBF;QAuBI;IAEJ;MADE;AAKJ;IACE,qBAAqB,EAAE,aAAa;IACpC,qBAAyB;EAC3B;AAEA;IACE,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;EA8CjB;AA5CE;MACE,UAAU;MACV,WAAW;MACX,WAAW;MACX,mBAA8B;MAA9B,8BAA8B;MAC9B,kBAAkB;MAClB,cAAc;MACd,2BAA2B;IAC7B;AAEA;MACE,WAAW;MACX,YAAY;MACZ,aAAa;MACb,aAAa;MACb,eAAe;MACf,uBAAuB;MACvB,mBAAmB;IAIrB;AAHE;QACE,aAAa;MACf;AAGF;MACE,qBAAqB;MACrB,kBAAkB;MAClB,gBAAgB;MAChB,aAAa;MACb,gBAAgB;IAClB;AAEA;MACE,sBAAsB;MACtB,kBAAkB;MAClB,6DAA6D;IAS/D;AALI;UACE,UAAU;UACV,mBAA8B;UAA9B,8BAA8B;QAChC;AAMR;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,4BAA4B;EAC5B,kBAAkB;EAClB,sCAAsC;AAWxC;AATE;IACE,cAAc;EAChB;AAGE;MACE,mBAA6B;MAA7B,6BAA6B;IAC/B;AAIJ;EACE,yBAAoC;EAApC,oCAAoC;AACtC;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AAEA;EACE,cAAc;EACd,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;AAEA;EACE,cAAuB;EAAvB,uBAAuB;EACvB,eAAe;AACjB;ACpLA;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,wCAAkD;EAAlD,kDAAkD;EAClD,oDAAoD;EACpD,gCAAgC;EAChC,4BAA4B;EAC5B,cAAuB;EAAvB,uBAAuB;EACvB,eAAe;AACjB;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,qCAAqC;EACrC,yBAA8B;EAA9B,8BAA8B;EAC9B,8CAA8C;EAC9C,kBAAkB;EAClB,wDAAwD;EACxD,eAAe;AACjB;AAEA;EACE,uCAAuC;EACvC,6CAA6C;AAC/C;AAEA;EACE,0CAA0C;AAC5C;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;AACrB;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAwB;EAAxB,wBAAwB;EACxB,uCAAuC;EACvC,8CAA8C;EAC9C,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AAEA;EACE,iBAAiB;EACjB,kCAAkC;AACpC;AAEA;EACE,mBAAmB;EACnB,cAA8B;EAA9B,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AAEA;EACE,cAAwB;EAAxB,wBAAwB;EACxB,eAAe;EACf,iBAAiB;AACnB;ACtEA;AACA;AAII;AADF;MAEI;EAEJ;IADE;AAKF;AADF;IAEI;AAEJ;EADE;AAGF;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AAEA;EACE,cAA8B;EAA9B,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAA8B;EAA9B,8BAA8B;EAC9B,8CAA8C;EAC9C,cAA2B;EAA3B,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,2BAA2B;AAC7B;AAEA;EACE,cAA8B;EAA9B,8BAA8B;AAChC;AAEA;EACE,cAAc;AAChB;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;AAC/B;AAEA;EACE,UAAU;AACZ;ACzEA;AACA;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,mBAAwB;EAAxB,wBAAwB;EACxB,kBAAkB;EAClB,8CAA8C;EAC9C,6BAA6B;EAC7B,uBAAuB;AAazB;AAXE;IACE,+BAA+B;EACjC;AAIE;MACE,+BAA+B;MAC/B,eAAe;IACjB;AAIJ;EACE,kBAAkB;AACpB;AAEA;EACE,cAAc;AAChB;AAEA;EACE,mBAAmB;EACnB,cAA8B;EAA9B,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AAEA;EACE,mBAAmB;EACnB,cAAwB;EAAxB,wBAAwB;EACxB,eAAe;EACf,iBAAiB;AACnB;AAEA;EACE,iBAAiB;EACjB,uCAAiD;EAAjD,iDAAiD;EACjD,kBAAkB;EAClB,8CAAwD;EAAxD,wDAAwD;AAY1D;AAVE;IACE,UAAU;IACV,aAAa;IACb,YAAY;IACZ,SAAS;EACX;AAEA;IACE,SAAS;EACX;AAGF;EACE,cAAwB;EAAxB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AAEA;EACE,cAA8B;EAA9B,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;AACnB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,cAAwB;EAAxB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AAEA;EACE,kCAA0B;EAA1B,0BAA0B;AAC5B;AAEA;EACE,kCAA0B;EAA1B,0BAA0B;AAC5B;AChGI;MACE,sBAAsB;IACxB;AAEA;AALF;MAMI,aAAa;MACb;EAEJ;IADE;AAGF;AAZF;IAaI,aAAa;IACb,iCAAiC;IACjC;AAWJ;;IATI;MACE,sBAAsB;MACtB,0BAA0B;MAC1B,kBAAkB;MAClB,cAAc;MACd,kBAAkB;MAClB,yBAAyB;IAC3B;EACF;AAGF;EACE,kBAAkB;EAClB,mBAAwB;EAAxB,wBAAwB;AAsB1B;AArBE,kDAAkD;AAClD,wCAAwC;AAExC;IACE,uCAAiD;IAAjD,iDAAiD;IACjD,sBAAsB;IACtB,8CAAwD;IAAxD,wDAAwD;IACxD,kBAAkB;IAClB,cAAuB;IAAvB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;EAOd;AALE;MACE,mBAAiC;MAAjC,iCAAiC;MACjC,gBAAgB;MAChB,YAAY;IACd;AAIJ;EACE,kBAAkB;EAClB,aAAa;EACb,+CAAgE;EAAhE,gEAAgE;EAChE,cAAwB;EAAxB,wBAAwB;EACxB,eAAe;AACjB;AAEA;EACE,qBAAqB;AACvB;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,eAAe;EACf,0BAA0B;EAC1B,yBAA8B;EAA9B,8BAA8B;EAC9B,+BAAuC;EAAvC,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AAEA;EACE,aAAa;AACf;AAEA;EACE,cAA8B;EAA9B,8BAA8B;EAC9B,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AAEA;EACE,uCAAiD;EAAjD,iDAAiD;EACjD,sBAAsB;EACtB,8CAAwD;EAAxD,wDAAwD;EACxD,kBAAkB;EAClB,cAAuB;EAAvB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;AAEA;EACE,uCAAiD;EAAjD,iDAAiD;EACjD,sBAAsB;EACtB,8CAAwD;EAAxD,wDAAwD;EACxD,kBAAkB;EAClB,cAAuB;EAAvB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;ACjHA;EACE,kBAAkB;EAClB,mBAAwB;EAAxB,wBAAwB;EACxB,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;AACf;AAEA;EACE,cAA8B;EAA9B,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;AACnB;AAEA;EACE,cAAwB;EAAxB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,qBAAa;UAAb,aAAa;EACb,gBAAgB;AAClB;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;AACjB;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,kBAAkB;EAClB,oDAAoD;EACpD,YAAY;EACZ,WAAW;AACb;AAEA;EACE,aAAa;AACf;AAEA;EACE;AACF;AAEA;EACE,aAAa;AACf;AAEA;EACE,aAAa;AACf;AAEA;EACE;AACF;AC9EA;CACC,gBAAgB;CAChB,SAAS;AACV;AAEA;EACE,kBAAkB;EAClB,yBAA8B;EAA9B,8BAA8B;EAC9B,8CAA8C;AAChD;AAEA;EACE,aAAa;EACb,+CAAgE;EAAhE,gEAAgE;AAClE;AAEA;EACE,qBAAqB;AACvB;AAEA;EACE,4BAA6C;EAA7C,6CAA6C;EAC7C,eAAe;AACjB;AAEA;EACE,cAAuB;EAAvB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAwB;EAAxB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uCAAiD;EAAjD,iDAAiD;EACjD,sBAAsB;EACtB,kBAAkB;EAClB,8CAAwD;EAAxD,wDAAwD;EACxD,cAAwB;EAAxB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AAEA;EACE,cAA2B;EAA3B,2BAA2B;AAC7B;ACvDA;EACE,kMAAkM;EAClM,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAA2C;EAA3C,2CAA2C;EAC3C,cAAc;AAChB;AAEA;EACE,SAAS;EACT,WAAW;EACX,yBAAyB;AAC3B;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AAEA;EACE,iBAAiB;AACnB;AAEA;AACA;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,8KAA8K;EAC9K,sBAAsB;AACxB;AAEA;EACE,wCAAkD;EAAlD,kDAAkD;EAClD,4BAAsC;EAAtC,sCAAsC;AACxC;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;AAEA;EACE,wBAAkD;EAAlD,kDAAkD;AACpD;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW;EACX,YAAY;EACZ,yBAA8B;EAA9B,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyC;EAAzC,yCAAyC;EACzC,WAAW;AACb;AAEA;EACE,YAAY;EACZ,6BAAuD;EAAvD,uDAAuD;EACvD,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,wMAAwM;EACxM,sBAAsB;AACxB;AAEA;EACE,sBAAsB;AACxB;AC3FA;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,+CAA+C;AAsCjD;AApCE;AAPF;IAQI;AAmCJ;;IAjCI;MACE,kBAAkB;IACpB;EACF;AAGE;AADF;MAEI;EAEJ;IADE;AAGF;IACE,WAAW;IACX,uBAAuB;EAWzB;AATE;AAJF;MAKI,mBAAmB;MACnB;EAOJ;IANE;AAEA;AATF;MAUI,sBAAsB;MACtB;EAEJ;IADE;AAGF;IACE,eAAe;EAKjB;AAJE;AAFF;MAGI,aAAa;MACb;EAEJ;IADE;AAIJ;EACE,cAAc;EACd,kBAAkB;AACpB;AAEA;EACE,kBAAkB;AAKpB;AAHE;AAHF;IAII;AAEJ;EADE;AAGF;EACE,cAAc;EACd,gBAAgB;AAalB;AAXE;IACE,iCAAiC;IACjC,yBAAyB;IACzB,2BAA2B;EAC7B;AAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;EACxB;AAGF;EACE,yBAAyC;EAAzC,yCAAyC;EACzC,eAAe;EACf,gBAAgB;AAuBlB;AArBE;IACE,yBAAyC;IAAzC,yCAAyC;IACzC,WAAW;EACb;AAHA;IACE,yBAAyC;IAAzC,yCAAyC;IACzC,WAAW;EACb;AAEA;IACE,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,oBAAoB;EAKtB;AAHE;MACE,2BAA2B;IAC7B;AAIJ;EACE,+BAA+B;EAC/B,eAAe;AAkBjB;AAhBE;IACE,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,qBAAqB;EAKvB;AAHE;MACE,2BAA2B;IAC7B;ACzHJ;AACA;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,4BAA4B;AAK9B;AAHE;AALF;IAMI;AAEJ;EADE;AAGF;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AAEA;EACE,kBAAkB;AAKpB;AAHE;AAHF;IAII;AAEJ;EADE;AAGF;EACE,cAAc;AAChB;AAEA;EACE,mBAAmB;EACnB,cAA8B;EAA9B,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AAEA;EACE,mBAAmB;EACnB,cAAwB;EAAxB,wBAAwB;EACxB,eAAe;EACf,iBAAiB;AACnB;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,cAAwB;EAAxB,wBAAwB;EACxB,eAAe;EACf,iBAAiB;AACnB;AAEA;EACE,cAAuB;EAAvB,uBAAuB;EACvB,gBAAgB;AAClB;AAEA;EACE,gBAAgB;EAChB,cAA0B;EAA1B,0BAA0B;EAC1B,eAAe;AACjB;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,+CAAgE;EAAhE,gEAAgE;AAClE;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;AAEA;EACE,cAAwB;EAAxB,wBAAwB;EACxB,eAAe;EACf,iBAAiB;AACnB;AAEA;EACE,cAA8B;EAA9B,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;ACxFE;IACE,eAAe;EAWjB;AATE;MACE,uCAAiD;MAAjD,iDAAiD;MACjD,sBAAsB;MACtB,8CAAwD;MAAxD,wDAAwD;MACxD,kBAAkB;MAClB,cAAuB;MAAvB,uBAAuB;MACvB,eAAe;MACf,iBAAiB;IACnB;AAIJ;EACE,aAAa;EACb,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAwB;EAAxB,wBAAwB;EACxB,kBAAkB;EAClB,8CAA8C;AAMhD;AAJE;AARF;IASI,sBAAsB;IACtB;AAEJ;EADE;AAGF;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AAEA;EACE,kBAAkB;AAKpB;AAHE;AAHF;IAII;AAEJ;EADE;AAGF;EACE,kBAAkB;EAClB,cAAc;AAChB;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,OAAO;EACP,WAAW;EACX,yBAA8B;EAA9B,8BAA8B;EAC9B,WAAW;AACb;AAEA;EACE,mBAAmB;EACnB,cAA8B;EAA9B,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,+CAAgE;EAAhE,gEAAgE;AAClE;AAEA;EACE,cAAwB;EAAxB,wBAAwB;EACxB,eAAe;EACf,iBAAiB;AACnB;AAEA;EACE,cAA8B;EAA9B,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;ACtFA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6CAA6C;EAC7C,6BAA6B;EAC7B,eAAe;AACjB;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AAEA;EACE,8CAA8C;AAChD;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;AAEA;EACE,WAAW;AACb;AAEA;EACE,WAAW;AACb;AAEA;EACE,WAAW;AACb;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAoC;EAApC,oCAAoC;EACpC,kBAAkB;EAClB,yBAA8B;EAA9B,8BAA8B;EAC9B,cAA0B;EAA1B,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;ACjEA;EACE,cAAc;EACd,uBAAuB;AACzB;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;ACVA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AAEA;EACE,cAA0B;EAA1B,0BAA0B;AAC5B;AAEA;EACE,cAAwB;EAAxB,wBAAwB;AAC1B;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;ACjBA;EACE,yBAAoC;EAApC,oCAAoC;EACpC,OAAO;AACT;AAEA;EACE;IACE,eAAe;EACjB;AACF;ACTA;EACE,kBAAkB;EAClB,mBAAwB;EAAxB,wBAAwB;AAC1B;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,oCAAoC;AACtC;ACTA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AAEA;EACE,cAA8B;EAA9B,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAA8B;EAA9B,8BAA8B;EAC9B,8CAA8C;EAC9C,cAA2B;EAA3B,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,2BAA2B;AAC7B;AAEA;EACE,cAA8B;EAA9B,8BAA8B;AAChC;AAEA;EACE,cAAc;AAChB;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;AAC/B;AAEA;EACE,UAAU;AACZ;ACjEA;EACE,eAAe;AAiBjB;AAdI;MACE,cAAwB;MAAxB,wBAAwB;IAC1B;AAGF;IACE,sBAAsB;EACxB;AAGE;AADF;MAEI;EAEJ;IADE;AAIJ;EACE;IACE,eAAe;EACjB;AACF;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,cAAmB;EAAnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AAEA;EACE;IACE,eAAe;IACf,eAAe;EACjB;AACF;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;AAEA;EACE,yBAAoC;EAApC,oCAAoC;AACtC;AACA;EACE,yBAAkC;EAAlC,kCAAkC;AACpC;AACA;EACE,yBAAyC;EAAzC,yCAAyC;AAC3C;AACA;EACE,yBAAmC;EAAnC,mCAAmC;AACrC;AACA;EACE,yBAAqC;EAArC,qCAAqC;AACvC;AACA;EACE,yBAAoC;EAApC,oCAAoC;AACtC;AACA;EACE,yBAAsC;EAAtC,sCAAsC;AACxC;AACA;EACE,yBAAmC;EAAnC,mCAAmC;AACrC;AC5EA;AACA;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,cAAwB;EAAxB,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mDAAmD;AACrD;AAEA;EACE,4BAAsC;EAAtC,sCAAsC;AACxC;AAEA;EACE,cAA8B;EAA9B,8BAA8B;EAC9B,4BAA4C;EAA5C,4CAA4C;AAC9C;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;AC1BA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,2CAAmD;EAAnD,mDAAmD;AACrD;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,cAAwB;EAAxB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AAEA;EACE,wCAAyD;EAAzD,yDAAyD;AAC3D;AAEA;EACE,mBAAmB;EACnB,8CAA8C;EAC9C,cAA8B;EAA9B,8BAA8B;AAChC;AzBGA,uBAAoB;A0B7BpB;IACI,sBAAsB;AAK1B;AAHI;AAHJ;QAIQ;AAER;IADI;AAGJ;IACI,WAAW;IACX,MAAM;IACN,WAAW;IACX,UAAU;AAgBd;AAdI;QACI,aAAa;QACb,uBAAuB;IAC3B;AAEA;AAXJ;QAYQ,gBAAgB;QAChB,gBAAgB;QAChB;AAMR;;QAJQ;YACI,cAAc;QAClB;IACJ;AAGJ;EACE,qBAAqB;AACvB;AAEA;IACI,sBAAsB;AAC1B;AAEA;;;;;;;;;;;;CAYC;A1BlBD,aAAU;A2B/BR;IACE,eAAe;EAWjB;AATE;MACE,uCAAiD;MAAjD,iDAAiD;MACjD,sBAAsB;MACtB,8CAAwD;MAAxD,wDAAwD;MACxD,kBAAkB;MAClB,cAAuB;MAAvB,uBAAuB;MACvB,eAAe;MACf,iBAAiB;IACnB;ACZJ;;EAEE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,gDAAgD;EAChD,kDAAkD;EAClD,mDAAmD;EACnD,gCAAgC;EAGhC,wBAAwB;EAExB,qCAAqC;AACvC;AAWA;EACE;IAEE,uBAAuB;EACzB;EACA;IAEE,yBAAyB;EAC3B;AACF;A5BJA,UAAO;A6BpCP;EACE,iBAAiB;AACnB;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AAoBrB;AAlBE;IACE,cAAwB;IAAxB,wBAAwB;IACxB,iBAAiB;EACnB;AAEA;IACE,kBAAkB;EACpB;AAGA;IACE,mBAA8B;IAA9B,8BAA8B;IAC9B,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;EACpB;ACzBA;IACE,gCAAgC;EAClC;AAEA;IACE,eAAe;IACf,cAA8B;IAA9B,8BAA8B;EAChC;AAEA;IACE,eAAe;IACf,cAAwB;IAAxB,wBAAwB;EAC1B;AAEA;IACE,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,SAAS;IACT,iBAAiB;EACnB;AAEA;IACE,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;EAsDnB;AApDE;MACE,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,UAAU;MACV,kCAAkC;IACpC;AAEA;MACE,kBAAkB;MAClB,MAAM;MACN,UAAU;MACV,WAAW;MACX,YAAY;MACZ,mDAAmD;MACnD,4BAA4B;MAC5B,sBAAsB;MACtB,wBAAwB;MACxB,wBAAwB;MACxB,iBAAiB;MACjB,yBAAyB;IAC3B;AAEA;MACE,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,UAAU;MACV,kBAAkB;MAClB,UAAU;MACV,SAAS;MACT,UAAU;MACV,yBAAyB;MACzB,iBAAiB;MACjB,kBAAkB;MAClB,yCAAyC;IAgB3C;AAdE;QACE,UAAU;MACZ;AAEA;QACE,aAAa;QACb,mBAAmB;QACnB,uBAAuB;MAMzB;AAJE;UACE,iBAAiB;UACjB,iBAAiB;QACnB;AAKN;IACE,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;EA8CZ;AA5CE;MACE,WAAW;MACX,yBAAyB;MACzB,qBAAqB;IAevB;AAbE;QACE,kBAAkB;QAClB,SAAS;QACT,WAAW;QACX,YAAY;QACZ,UAAU;QACV,kBAAkB;QAClB,sBAAsB;QACtB,UAAU;QACV,WAAW;QACX,WAAW;QACX,qCAAqC;MACvC;AAGF;MACE,2BAA2B;MAC3B,6BAA6B;MAC7B,qBAAqB;IACvB;AAEA;MACE,YAAY;MACZ,kCAAkC;MAClC,gBAAgB;IAclB;AAZE;QACE,cAAc;QACd,sCAAsC;QACtC,gBAAgB;QAChB,kCAAkC;MAOpC;AALE;UACE,gBAAgB;UAChB,kCAAkC;UAClC,aAAa;QACf;AAKN;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,cAA8B;IAA9B,8BAA8B;IAC9B,0CAA0C;;EAwC5C;AAtCE;MACE,yBAAyB;MACzB,iBAAiB;IACnB;AAEA;MACE,mBAAmB;MACnB,YAAY;MACZ,yBAAyB;IAC3B;AAEA;MACE,gBAAgB;MAChB,uBAAuB;MACvB,YAAY;MACZ,eAAe;MACf,iBAAiB;IAcnB;AAZE;QACE,gBAAgB;QAChB,uBAAuB;QACvB,YAAY;QACZ,eAAe;QACf,qBAAqB;QACrB,iBAAiB;MAKnB;AAHE;UACE,aAAa;QACf;AAIJ;MACE,6BAA6B;MAC7B,eAAe;MACf,oBAAoB;IACtB;AAIF;IACE,eAAe;IACf,WAAW;IACX,aAAa;IACb,2BAA2B;IAC3B,8BAA8B;IAC9B,aAAa;EAOf;AALE;MACE,WAAW;MACX,aAAa;MACb,yBAAyB;IAC3B;A9B1JJ,SAAM;A+BxCN;EACE,aAAa;AACf;AAGA,aAAa;AACb;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;AACnB;AAEA;EACE,qBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EAGtB,qBAAqB;EACrB,aAAa;AACf;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;EACxB,iBAAiB;EACjB,YAAY;AACd;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;AAEA;EACE,gBAAgB;EAChB,iBAAiB;GAChB,aAAa;AAChB;AAGA;EACE,wCAAgC;EAAhC,gCAAgC;EAChC,sBAAsB;EACtB,uBAAuB;AACzB;AAEA;EACE,yBAAyB;AAC3B;AAEA;EACE,aAAa;AACf;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA4CE;A/B3EF,UAAO;AgC1CL;IACE,kBAAkB;EACpB;AAIA;IACE,4BAA4B;IAC5B,6BAA6B;IAC7B,yCAAyC;IACzC,6BAA6B;EAC/B;AAMI;QACE,gCAA2C;QAA3C,2CAA2C;MAC7C;AhC0BN,WAAQ;AiC7CN;IACE,aAAa;EACf;AAEA;IACE,cAAc;EAChB;AAIA;IACE,eAAgB;IAAhB,gBAAgB;EAClB;AAEA;IACE,aAAa;EACf;AjCgCF,UAAO;AkCjDP;EACE,qBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EAGtB,qBAAqB;EACrB,aAAa;AACf","sourcesContent":["// Variables\n@import \"components/variables\";\n@import \"partials/variables\";\n\n// Frontend\n@import \"components/typography\";\n@import \"components/aside\";\n@import \"components/buttons\";\n@import \"components/user\";\n@import \"components/audiences\";\n@import \"components/audience-build\";\n@import \"components/audience-build-modal\";\n@import \"components/audience-create-filters\";\n@import \"components/audience-exports\";\n@import \"components/audience-report\";\n@import \"components/aside-navigation\";\n@import \"components/content-head\";\n@import \"components/connections-destinations\";\n@import \"components/connections-sources\";\n@import \"components/icon-item\";\n@import \"components/logo\";\n@import \"components/percent-change\";\n@import \"components/main-content\";\n@import \"components/section-body\";\n@import \"components/section-head\";\n@import \"components/table\";\n@import \"components/tabs-nav\";\n@import \"components/true-false-toggle\";\n\n// Structure & Layout\n@import \"partials/layout\";\n\n// Elements\n@import \"partials/section\";\n@import \"partials/animations\";\n\n// Pages\n@import \"partials/pages/signal-routing\";\n@import \"partials/pages/onboarding\";\n\n// Misc\n@import \"partials/misc\";\n\n// Forms\n@import \"partials/forms\";\n\n// Loader\n@import \"partials/loader\";\n\n// Utils\n@import \"partials/utils\";\n",":root {\n  --athens-gray: #efeff0;\n  --athens-gray-rgb: 239, 239, 240;\n  --light-sky-gray: #f4f4f7;\n  --light-sky-gray-rgb: 244, 244, 247;\n  --port-gore: #1c1740;\n  --port-gore-rgb: 28, 23, 64;\n  --storm-gray: #706e80;\n  --storm-gray-rgb: 112, 110, 128;\n  --vortex-blue: #109cf1;\n  --vortex-blue-rgb: 16, 156, 241;\n  --vortex-deep-blue: #172b4d;\n  --vortex-deep-blue-rgb: 23, 43, 77;\n  --vortex-green: #1fa463;\n  --vortex-green-rgb: 31, 164, 99;\n  --vortex-orange: #fe8663;\n  --vortex-orange-rgb: 254, 134, 99;\n  --vortex-red: #ff5c5c;\n  --vortex-red-rgb: 255, 92, 92;\n  --white: #ffffff;\n  --white-rgb: 255, 255, 255;\n}\n","// Grid Breakpoints\n\n$xl: 1200px;\n$lg: 992px;\n$md: 768px;\n$sm: 576px;","body {\n  color: var(--port-gore);\n}\n\na {\n  color: inherit;\n}\n\na:hover {\n  color: inherit;\n  text-decoration: none;\n}\n",".aside {\n  display: flex;\n  flex-flow: column;\n  position: relative;\n  background-color: var(--white);\n  border-right: 2px solid #dee3ec;\n}\n\n@media (min-width: 992px) {\n  .aside {\n    position: sticky;\n    height: 100vh;\n    top: 0;\n    overflow-y: auto;\n  }\n}\n\n.aside-user {\n  padding: 12px 10px 10px;\n  margin-top: auto;\n}\n\n.aside__hamburger {\n  position: absolute;\n  top: -66px;\n}\n",".ellipsis-button {\n  border: 0 none;\n  background-color: transparent;\n  color: rgba(var(--vortex-deep-blue-rgb), 0.5);\n  transition: color 0.1s ease;\n  cursor: pointer;\n}\n\n.ellipsis-button:hover {\n  color: rgba(var(--vortex-deep-blue-rgb), 1);\n}\n\n.ellipsis-button:focus {\n  outline: none;\n}\n\n.trash-bin-button {\n  color: var(--port-gore);\n  opacity: 0.2;\n  transition: opacity 0.1s ease;\n  font-size: 17px;\n  cursor: pointer;\n}\n\n.trash-bin-button:hover {\n  opacity: 0.5;\n}\n\n\n.tmp-fly-btn--primary {\n  color: rgb(249, 251, 255) !important;\n  background-color: rgb(56, 105, 199) !important;\n  border-color: rgb(56, 105, 199) !important;\n}\n\n.tmp-fly-border-btn {\n  border: 1px solid rgb(222, 227, 236);\n}\n\n.tmp-fly-btn {\n  padding: 11px 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 19px;\n  letter-spacing: 0px;\n  border-width: 2px;\n  border-style: solid;\n  border-radius: 6px;\n  cursor: pointer;\n  background: rgb(255, 255, 255);\n  color: rgb(127, 122, 147);\n  border-color: rgb(222, 227, 236);\n}",".user {\n  display: flex;\n  align-items: center;\n\n  &__avatar {\n    border-radius: 100%;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    width: 38px;\n    height: 38px;\n    text-transform: uppercase;\n    color: rgba(255, 255, 255, 0.9);\n    font-weight: bold;\n    font-size: 16px;\n  }\n  \n  &-profile {\n    max-width: 1100px;\n\n    > .row {\n      @media screen and (max-width: $md) {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n      }\n    }\n\n    &__information {\n      padding: 2rem;\n    }\n\n    &__avatar-wrapper {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      max-width: 300px;\n\n      @media screen and (min-width: $sm) {\n        justify-content: flex-start;\n        align-items: flex-start;\n        max-width: 150px;\n      }\n    }\n\n    hr {\n      border-top: 0;\n      border-bottom: 1px solid rgba(var(--vortex-deep-blue-rgb), 0.07);\n    }\n\n    .user__avatar {\n      width: 100%;\n      padding-bottom: 100%;\n      height: 0;\n      border-radius: 4px;\n      position: relative;\n\n      &-initial {\n        position: absolute;\n        display: flex;\n        width: 100%;\n        height: 100%;\n        justify-content: center;\n        align-items: center;\n        font-size: 4rem;\n        top: 0;\n      }\n\n      @media screen and (min-width: $md) {\n        max-width: 200px;\n      }\n\n      @media screen and (max-width: $md) {\n        margin-right: 0 !important;\n      }\n    }\n  }\n\n\n  &__nickname {\n    word-wrap: break-word; /* old name */\n    overflow-wrap: break-word;\n  }\n\n  &__menu {\n    display: inline-flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n\n    .circle {\n      width: 5px;\n      height: 5px;\n      margin: 3px;\n      background: var(--athens-gray);\n      border-radius: 50%;\n      display: block;\n      transition: background 0.2s;\n    }\n    \n    > div {\n      width: 60px;\n      height: 60px;\n      padding: 20px;\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: center;\n      align-items: center;\n      &:hover, &:focus {\n        outline: none;\n      }\n    }\n\n    > span {\n      display: inline-block;\n      text-align: center;\n      line-height: 1.2;\n      padding: 20px;\n      margin-top: auto;\n    }\n\n    &-button {\n      flex-direction: column;\n      position: relative;\n      transition: all 300ms cubic-bezier(0.175, 0.885, 0.32, 1.275);\n\n      &:hover,\n      &:focus {\n        .circle {\n          opacity: 1;\n          background: var(--vortex-blue);\n        }\n      }\n    }\n  }\n}\n\n.user__button {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 10px 10px 10px;\n  border-radius: 5px;\n  transition: background-color 0.1s ease;\n\n  .dropup {\n    line-height: 0;\n  }\n\n  &:hover {\n    .circle {\n      background: var(--storm-gray);\n    }\n  }\n}\n\n.user__button:hover {\n  background-color: var(--athens-gray);\n}\n\n.user__row {\n  display: flex;\n  align-items: center;\n}\n\n.user__image {\n  display: block;\n  flex: 0 0 auto;\n  width: 36px;\n  height: 36px;\n  margin-right: 14px;\n  border-radius: 50%;\n}\n\n.user__name {\n  color: var(--port-gore);\n  font-size: 14px;\n}\n",".audiences__search-textbox {\n  height: 49px;\n  padding-left: 54px;\n  border: 0 none;\n  border-radius: 5px;\n  background-color: rgba(var(--port-gore-rgb), 0.04);\n  /* background-image: url(\"/images/magnifier.svg\"); */\n  background-position: 21px center;\n  background-repeat: no-repeat;\n  color: var(--port-gore);\n  font-size: 14px;\n}\n\n.audiences__item {\n  height: 100%;\n  padding: 30px 30px 35px 30px;\n  border:  1px solid rgb(222, 227, 236);\n  background-color: var(--white);\n  box-shadow: 0px 2px 4px rgba(28, 23, 64, 0.05);\n  border-radius: 5px;\n  transition: border-color 0.1s ease, box-shadow 0.1s ease;\n  cursor: pointer;\n}\n\n.audiences__item:hover {\n  border: 2px solid rgba(28, 23, 64, 0.1);\n  box-shadow: 0px 2px 4px rgba(28, 23, 64, 0.1);\n}\n\n.audiences__item.-dashed-border {\n  border: 2px dashed rgba(60, 51, 139, 0.11);\n}\n\n.audiences__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: 36px;\n}\n\n.audiences__counter {\n  display: flex;\n  align-items: center;\n  padding: 15px;\n  background: var(--white);\n  border: 1px solid rgba(28, 23, 64, 0.1);\n  box-shadow: 0px 2px 4px rgba(28, 23, 64, 0.05);\n  border-radius: 5px;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1;\n}\n\n.audiences__counter-icon {\n  margin-right: 5px;\n  color: var(--audiences-item-color);\n}\n\n.audiences__title {\n  margin-bottom: 12px;\n  color: var(--vortex-deep-blue);\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 21px;\n}\n\n.audiences__text {\n  color: var(--storm-gray);\n  font-size: 14px;\n  line-height: 21px;\n}\n",".audience-build {\n}\n\n.audience-build__main {\n  #new-audience-btn {\n    @media screen and (max-width: $md) {\n      padding-right: .2em;\n    }  \n  }\n}\n\n.audience-build__aside {\n  @media screen and (max-width: $lg) {\n    margin-top: 2em;\n  }\n}\n\n.audience-build__head {\n  display: flex;\n  align-items: center;\n  min-height: 36px;\n  margin-bottom: 10px;\n}\n\n.audience-build__title {\n  color: var(--vortex-deep-blue);\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 21px;\n}\n\n.audience-build__head-actions {\n  display: flex;\n  flex: 0 0 auto;\n  margin-left: auto;\n  padding-left: 10px;\n}\n\n.audience-build__head-action {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 36px;\n  margin-left: 8px;\n  padding: 5px 18px;\n  border-radius: 5px;\n  background-color: var(--white);\n  box-shadow: 0px 2px 4px rgba(28, 23, 64, 0.05);\n  color: var(--vortex-orange);\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 17px;\n  cursor: pointer;\n  transition: color 0.1s ease;\n}\n\n.audience-build__head-action:hover {\n  color: var(--vortex-deep-blue);\n}\n\n.audience-build__head-action:first-child {\n  margin-left: 0;\n}\n\n.audience-build__head-action-icon {\n  margin-right: 10px;\n  font-weight: 400;\n  opacity: 0.8;\n  transition: opacity 0.1s ease;\n}\n\n.audience-build__head-action:hover .audience-build__head-action-icon {\n  opacity: 1;\n}\n",".audience-build-modal {\n}\n\n.audience-build-modal__item {\n  display: flex;\n  position: relative;\n  padding: 28px 30px;\n  background: var(--white);\n  border-radius: 5px;\n  box-shadow: 0px 2px 4px rgba(28, 23, 64, 0.05);\n  border: 2px solid transparent;\n  transition: border 0.2s;\n\n  &.active {\n    border: 2px solid var(--orange);\n  }\n\n\n  &--hover-select {\n    &:hover, &:focus {\n      border: 2px solid var(--orange);\n      cursor: pointer;\n    }\n  }\n}\n\n.audience-build-modal__icon {\n  margin-right: 30px;\n}\n\n.audience-build-modal__content {\n  flex: 1 1 auto;\n}\n\n.audience-build-modal__title {\n  margin-bottom: 10px;\n  color: var(--vortex-deep-blue);\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 21px;\n}\n\n.audience-build-modal__description {\n  margin-bottom: 35px;\n  color: var(--storm-gray);\n  font-size: 14px;\n  line-height: 17px;\n}\n\n.audience-build-modal__infobox {\n  padding: 8px 18px;\n  border: 1px solid rgba(var(--port-gore-rgb), 0.1);\n  border-radius: 5px;\n  box-shadow: 0px 2px 4px rgba(var(--port-gore-rgb), 0.05);\n\n  .form-control {\n    padding: 0;\n    display: flex;\n    height: auto;\n    border: 0;\n  }\n\n  .form-group {\n    margin: 0;\n  }\n}\n\n.audience-build-modal__infobox-name {\n  color: var(--storm-gray);\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 12px;\n}\n\n.audience-build-modal__infobox-content {\n  color: var(--vortex-deep-blue);\n  font-size: 14px;\n  line-height: 17px;\n}\n\n.audience-build-modal__decisive-buttons .btn {\n  min-width: 198px;\n}\n\n.audience-build-modal__cancel {\n  color: var(--storm-gray);\n  font-size: 14px;\n  font-weight: 600;\n  text-align: center;\n  cursor: pointer;\n}\n\n.audience-build-modal__cancel:hover {\n  text-decoration: underline;\n}\n\n.audience-build-modal__select-control a:hover {\n  text-decoration: underline;\n}\n",".filter {\n  &-body {\n    .select2-container {\n      width: 100% !important;\n    }\n\n    @media screen and (max-width: $md) {\n      display: flex;\n      flex-direction: column !important;\n    }\n  }\n\n  @media screen and (max-width: $md) {\n    display: flex;\n    flex-direction: column !important;\n    align-items: flex-start !important;\n\n    [class^=\"col\"], [class*=\" col\"] {\n      width: 100% !important;\n      max-width: 100% !important;\n      flex: 1 !important;\n      display: block;\n      margin-bottom: 1em;\n      padding: 0 1em !important;\n    }\n  }\n}\n\n.audience-create-filters {\n  border-radius: 5px;\n  background: var(--white);\n  /*box-shadow: 0px 2px 4px rgba(28, 23, 64, 0.05);*/\n  /*border: 2px solid rgb(222, 227, 236);*/\n\n  &__item {\n    border: 1px solid rgba(var(--port-gore-rgb), 0.1);\n    box-sizing: border-box;\n    box-shadow: 0px 2px 4px rgba(var(--port-gore-rgb), 0.05);\n    border-radius: 5px;\n    color: var(--port-gore);\n    font-size: 14px;\n    line-height: 17px;\n    text-align: center;\n    padding: 1em 1.2em;\n    margin: .5em;\n\n    &.-muted {\n      background: var(--light-sky-gray);\n      box-shadow: none;\n      border: none;\n    }\n  }\n}\n\n.audience-create-filters__section {\n  position: relative;\n  padding: 30px;\n  border-bottom: 1px solid rgba(var(--vortex-deep-blue-rgb), 0.07);\n  color: var(--storm-gray);\n  font-size: 14px;\n}\n\n.audience-create-filters:last-child {\n  border-bottom: 0 none;\n}\n\n.audience-create-filters__section::after {\n  display: block;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  padding: 0 30px;\n  transform: translateY(50%);\n  background-color: var(--white);\n  color: rgba(var(--storm-gray-rgb), 0.5);\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 14px;\n  content: \"AND\";\n}\n\n.audience-create-filters__section:last-child::after {\n  display: none;\n}\n\n.audience-create-filters__title {\n  color: var(--vortex-deep-blue);\n  word-wrap: break-word;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 17px;\n}\n\n.audience-create-filters__section input[type=\"text\"] {\n  border: 1px solid rgba(var(--port-gore-rgb), 0.1);\n  box-sizing: border-box;\n  box-shadow: 0px 2px 4px rgba(var(--port-gore-rgb), 0.05);\n  border-radius: 5px;\n  color: var(--port-gore);\n  font-size: 14px;\n  line-height: 17px;\n  text-align: center;\n}\n\n.audience-create-filters__section select {\n  border: 1px solid rgba(var(--port-gore-rgb), 0.1);\n  box-sizing: border-box;\n  box-shadow: 0px 2px 4px rgba(var(--port-gore-rgb), 0.05);\n  border-radius: 5px;\n  color: var(--port-gore);\n  font-size: 14px;\n  line-height: 17px;\n  text-align: center;\n}\n",".audience-exports {\n  border-radius: 8px;\n  background: var(--white);\n  border: 2px solid rgb(222, 227, 236);\n  overflow-x: scroll;\n  display: flex;\n}\n\n.audience-exports__table {\n  color: var(--vortex-deep-blue);\n  font-size: 14px;\n  line-height: 17px;\n}\n\n.audience-exports__table th {\n  color: var(--storm-gray);\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 14px;\n  vertical-align: middle;\n}\n.audience-exports__table td {\n  vertical-align: middle;\n  word-wrap: break-word;\n  hyphens: auto;\n  max-width: 270px;\n}\n\n.audience-exports__table-icon {\n  display: flex;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  color: var(--audience-exports-icon-color);\n  font-size: 18px;\n}\n\n.audience-exports__table-icon-image {\n  display: block;\n  width: 18px;\n  height: auto;\n}\n\n.audience-exports__table-icon::after {\n  display: block;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  border-radius: 50%;\n  background-color: var(--audience-exports-icon-color);\n  opacity: 0.1;\n  content: \"\";\n}\n\n#task-owner-checkbox {\n  display: none;\n}\n\n#opportunity-owner {\n  display: none\n}\n\n#lead-source-for-new-opportunity {\n  display: none;\n}\n\n#lead-source-for-new-lead {\n  display: none;\n}\n\n.dynamics-activity-type {\n  display: none\n}\n",".audience-build__aside {\n position: sticky; \n top: 25px;\n}\n\n.audience-report {\n  border-radius: 5px;\n  background-color: var(--white);\n  box-shadow: 0px 2px 4px rgba(28, 23, 64, 0.05);\n}\n\n.audience-report__section {\n  padding: 30px;\n  border-bottom: 1px solid rgba(var(--vortex-deep-blue-rgb), 0.07);\n}\n\n.audience-report__section:last-child {\n  border-bottom: 0 none;\n}\n\n.audience-report__icon {\n  color: rgba(var(--vortex-deep-blue-rgb), 0.5);\n  font-size: 15px;\n}\n\n.audience-report__number {\n  color: var(--port-gore);\n  font-size: 24px;\n  line-height: 29px;\n}\n\n.audience-report__number-label {\n  display: flex;\n  align-items: center;\n  margin-top: 3px;\n  color: var(--storm-gray);\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.audience-report__percent {\n  margin-left: 5px;\n  padding: 3px 6px;\n  border: 1px solid rgba(var(--port-gore-rgb), 0.1);\n  box-sizing: border-box;\n  border-radius: 5px;\n  box-shadow: 0px 2px 4px rgba(var(--port-gore-rgb), 0.05);\n  color: var(--storm-gray);\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 14px;\n}\n\n.audience-report__percent.-orange {\n  color: var(--vortex-orange);\n}\n",".aside-navigation__label {\n  font-family: \"Work Sans\",apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";\n  font-size: 14px;\n  font-weight: 500;\n  margin-top: 24px;\n  display: var(--fly-nav-label-display,block);\n  color: #634960;\n}\n\n.aside-navigation__separator {\n  border: 0;\n  height: 1px;\n  background-color: #f0f1f3;\n}\n\n.aside-navigation__list {\n  margin: 0;\n  padding: 0 1rem;\n  list-style: none;\n  width: 100%;\n}\n\n.aside-navigation__list li:first-of-type {\n  padding: 12px 0 0;\n}\n\n.aside-navigation__list li:last-of-type {\n}\n\n.aside-navigation__link {\n  display: flex;\n  align-items: center;\n  margin-bottom: 5px;\n  padding: 12.25px 14px;\n  border-radius: 6px;\n  transition: color 0.1s ease;\n  color: #4f4c58;\n  font-size: 16px;\n  font-weight: normal;\n  font-family: Rubik,apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;\n  box-sizing: border-box;\n}\n\n.aside-navigation__link:hover {\n  background-color: rgba(var(--port-gore-rgb), 0.05);\n  color: rgba(var(--port-gore-rgb), 0.8);\n}\n\n.aside-navigation__link.-active {\n  color: #1d2637;\n  background-color: #eff5ff;\n}\n\n.aside-navigation__icon {\n  position: relative;\n  margin-right: 12px;\n  font-size: 1.25rem;\n}\n\n.aside-navigation__link.-active .aside-navigation__icon {\n  color: var(--fly-color-primary, rgb(56, 105, 199));\n}\n\n.aside-navigation__link.-notify-dot .aside-navigation__icon::after {\n  display: block;\n  position: absolute;\n  top: -4px;\n  left: 9px;\n  width: 12px;\n  height: 12px;\n  border: 2px solid var(--white);\n  border-radius: 50%;\n  background-color: var(--vortex-deep-blue);\n  content: \"\";\n}\n\n.beta-badge {\n  color: white;\n  background: var(--fly-color-primary, rgb(56, 105, 199));\n  font-size: 12px;\n  padding: 3px 8px;\n  border-radius: 6px;\n  margin-left: 12px;\n  font-style: normal;\n  font-weight: normal;\n  font-family: Rubik, apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  box-sizing: border-box;\n}\n\n.navbar-collapse {\n  flex-direction: column;\n}\n",".content-head {\n  display: flex;\n  align-items: flex-start;\n  padding: 55px 0 30px;\n  margin-bottom: 40px;\n  border-bottom: 1px solid rgba(28, 23, 64, 0.07);\n\n  @media screen and (max-width: $sm) {\n    flex-direction: column;\n\n    > div {\n      margin-bottom: 1em;\n    }\n  }\n\n  &#audience-build-content-head {\n    @media screen and (max-width: $md) {\n      flex-direction: column;\n    }\n  }\n\n  #audience-header {\n    width: 100%;\n    align-items: flex-start;\n\n    @media screen and (max-width: $md) {\n      align-items: center;\n      margin-top: 2em;\n    }\n\n    @media screen and (max-width: $sm) {\n      flex-direction: column;\n      align-items: flex-start;\n    }\n  }\n\n  #audience-submit-button {\n    margin-top: 1em;\n    @media screen and (min-width: $sm) {\n      margin-top: 0;\n      margin-left: 1em;\n    }\n  }\n}\n\n.content-head__back {\n  flex: 0 0 auto;\n  margin-right: 30px;\n}\n\n.content-head__icon {\n  margin-right: 20px;\n\n  @media screen and (max-width: $sm) {\n    display: none !important;\n  }\n}\n\n.content-head__text {\n  flex: 1 1 auto;\n  overflow: hidden;\n\n  .form-control {\n    border-color: rgba(0, 0, 0, 0.09);\n    max-width: 75% !important;\n    min-width: 400px !important;\n  }\n\n  form {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n}\n\n.content-head__title {\n  color: var(--vortex-deep-blue) !important;\n  font-size: 24px;\n  font-weight: 700;\n\n  &::placeholder {\n    color: var(--vortex-deep-blue) !important;\n    opacity: .5;\n  }\n\n  &.form-control {\n    width: auto;\n    height: auto;\n    background: transparent;\n    border-radius: 0;\n    padding: 0;\n    border-top: 0;\n    border-left: 0;\n    border-right: 0;\n    border-width: 2px;\n    margin-bottom: .15em;\n\n    &:focus {\n      border-color: var(--orange);\n    }\n  }\n}\n\n.content-head__subtitle {\n  color: var(--vortex-storm-gray);\n  font-size: 14px;\n\n  &.form-control {\n    width: auto;\n    height: auto;\n    background: transparent;\n    border-radius: 0;\n    padding: 0;\n    border-top: 0;\n    border-left: 0;\n    border-right: 0;\n    border-width: 2px;\n    padding-bottom: .25em;\n    \n    &:focus {\n      border-color: var(--orange);\n    }\n  }\n}\n",".connections-destinations {\n}\n\n.connections-destinations__item {\n  display: flex;\n  position: relative;\n  padding: 30px 80px 30px 36px;\n\n  @media screen and (max-width: $md) {\n    flex-direction: column;\n  }\n}\n\n.connections-destinations__options-button {\n  position: absolute;\n  top: 30px;\n  right: 35px;\n}\n\n.connections-destinations__icon {\n  margin-right: 70px;\n\n  @media screen and (max-width: $md) {\n    margin-bottom: 2em;\n  }\n}\n\n.connections-destinations__content {\n  flex: 1 1 auto;\n}\n\n.connections-destinations__title {\n  margin-bottom: 10px;\n  color: var(--vortex-deep-blue);\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 21px;\n}\n\n.connections-destinations__description {\n  margin-bottom: 35px;\n  color: var(--storm-gray);\n  font-size: 14px;\n  line-height: 17px;\n}\n\n.connections-destinations__info {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  color: var(--storm-gray);\n  font-size: 14px;\n  line-height: 21px;\n}\n\n.connections-destinations__info-date {\n  color: var(--port-gore);\n  font-weight: 700;\n}\n\n.connections-destinations__info-icon {\n  margin-left: 5px;\n  color: var(--vortex-green);\n  font-size: 15px;\n}\n\n.connections-destinations__entry {\n  padding-bottom: 15px;\n  margin-bottom: 15px;\n  border-bottom: 1px solid rgba(var(--vortex-deep-blue-rgb), 0.07);\n}\n\n.connections-destinations__entry:last-child {\n  margin-bottom: 0;\n  padding-bottom: 0;\n  border-bottom: 0 none;\n}\n\n.connections-destinations__entry-name {\n  color: var(--storm-gray);\n  font-size: 14px;\n  line-height: 17px;\n}\n\n.connections-destinations__entry-value {\n  color: var(--vortex-deep-blue);\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 17px;\n}\n",".connections-sources {\n  &__edit-fields {\n    padding: 1.5rem;\n\n    input[type=\"text\"], textarea, select {\n      border: 1px solid rgba(var(--port-gore-rgb), 0.1);\n      box-sizing: border-box;\n      box-shadow: 0px 2px 4px rgba(var(--port-gore-rgb), 0.05);\n      border-radius: 5px;\n      color: var(--port-gore);\n      font-size: 14px;\n      line-height: 17px;\n    }\n  }\n}\n\n.connections-sources__item {\n  display: flex;\n  position: relative;\n  padding: 30px 80px 30px 36px;\n  background: var(--white);\n  border-radius: 5px;\n  box-shadow: 0px 2px 4px rgba(28, 23, 64, 0.05);\n\n  @media screen and (max-width: $md) {\n    flex-direction: column;\n    margin-bottom: 2em;\n  }\n}\n\n.connections-sources__options-button {\n  position: absolute;\n  top: 30px;\n  right: 35px;\n}\n\n.connections-sources__icon {\n  margin-right: 70px;\n\n  @media screen and (max-width: $md) {\n    margin-bottom: 2em;\n  }\n}\n\n.connections-sources__content {\n  position: relative;\n  flex: 1 1 auto;\n}\n\n.connections-sources__content::after {\n  display: block;\n  position: absolute;\n  right: 0;\n  bottom: 15px;\n  left: 0;\n  height: 1px;\n  background-color: var(--white);\n  content: \"\";\n}\n\n.connections-sources__title {\n  margin-bottom: 25px;\n  color: var(--vortex-deep-blue);\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 21px;\n}\n\n.connections-sources__entry {\n  padding-bottom: 15px;\n  padding-right: 2em;\n  margin-bottom: 15px;\n  border-bottom: 1px solid rgba(var(--vortex-deep-blue-rgb), 0.07);\n}\n\n.connections-sources__entry-name {\n  color: var(--storm-gray);\n  font-size: 14px;\n  line-height: 17px;\n}\n\n.connections-sources__entry-value {\n  color: var(--vortex-deep-blue);\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 17px;\n}",".icon-item {\n  display: flex;\n  position: relative;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: center;\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  background-color: var(--icon-item-background);\n  color: var(--icon-item-color);\n  font-size: 24px;\n}\n\n.icon-item.-big {\n  width: 84px;\n  height: 84px;\n  font-size: 30px;\n}\n\n.icon-item.-small {\n  width: 48px;\n  height: 48px;\n  font-size: 18px;\n}\n\n.icon-item.-xsmall {\n  width: 30px;\n  height: 30px;\n  font-size: 16px;\n}\n\n.icon-item.-shadow {\n  box-shadow: 0px 2px 4px rgba(28, 23, 64, 0.05);\n}\n\n.icon-item__image {\n  display: block;\n  width: 30px;\n  height: auto;\n}\n\n.icon-item.-big .icon-item__image {\n  width: 36px;\n}\n\n.icon-item.-small .icon-item__image {\n  width: 18px;\n}\n\n.icon-item.-xsmall .icon-item__image {\n  width: 16px;\n}\n\n.icon-item__check {\n  position: absolute;\n  right: -4px;\n  bottom: -4px;\n  border: 4px solid var(--athens-gray);\n  border-radius: 50%;\n  background-color: var(--white);\n  color: var(--vortex-green);\n  font-size: 16px;\n  line-height: 16px;\n  cursor: pointer;\n}\n",".logo {\n  display: block;\n  padding: 24px 15px 12px;\n}\n\n.logo__image {\n  display: block;\n  max-width: 100%;\n  height: auto;\n  margin: 0 auto;\n}\n",".percent-change {\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 14px;\n}\n\n.percent-change.-green {\n  color: var(--vortex-green);\n}\n\n.percent-change.-red {\n  color: var(--vortex-red);\n}\n\n.percent-change__icon {\n  margin-right: 3px;\n  font-size: 8px;\n}\n",".main-content {\n  background-color: var(--athens-gray);\n  flex: 1;\n}\n\n@media (min-width: 992px) {\n  .main-content {\n    padding: 0 30px;\n  }\n}\n",".section-body {\n  border-radius: 5px;\n  background: var(--white);\n}\n\n.outlined-section-body {\n  @extend .section-body;\n  border-radius: 5px;\n  border: 2px solid rgb(222, 227, 236);\n}",".section-head {\n  display: flex;\n  align-items: center;\n  min-height: 39px;\n  margin-bottom: 10px;\n}\n\n.section-head__title {\n  color: var(--vortex-deep-blue);\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 21px;\n}\n\n.section-head__sync {\n  display: flex;\n  flex: 0 0 auto;\n  align-items: center;\n  margin-left: auto;\n  padding-left: 10px;\n  font-size: 12px;\n}\n\n.section-head__actions {\n  display: flex;\n  flex: 0 0 auto;\n  margin-left: auto;\n  padding-left: 10px;\n}\n\n.section-head__action {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 36px;\n  margin-left: 8px;\n  padding: 5px 18px;\n  border-radius: 5px;\n  background-color: var(--white);\n  box-shadow: 0px 2px 4px rgba(28, 23, 64, 0.05);\n  color: var(--vortex-orange);\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 17px;\n  cursor: pointer;\n  transition: color 0.1s ease;\n}\n\n.section-head__action:hover {\n  color: var(--vortex-deep-blue);\n}\n\n.section-head__action:first-child {\n  margin-left: 0;\n}\n\n.section-head__action-icon {\n  margin-right: 10px;\n  font-weight: 400;\n  opacity: 0.8;\n  transition: opacity 0.1s ease;\n}\n\n.section-head__action:hover .section-head__action-icon {\n  opacity: 1;\n}\n",".table {\n  font-size: 10px;\n\n  .list {\n    a:hover {\n      color: var(--storm-gray);\n    }\n  }\n\n  .select2-container {\n    width: 100% !important;\n  }\n\n  .user__info {\n    @media screen and (max-width: $md) {\n      display: none !important;\n    }\n  }\n}\n\n@media (min-width: 1200px) {\n  .table {\n    font-size: 12px;\n  }\n}\n\n.table__label {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 0;\n  min-height: 40px;\n  padding: 5px;\n  border-radius: 5px;\n  color: var(--white);\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 14px;\n}\n\n@media (min-width: 992px) {\n  .table__label {\n    min-width: 90px;\n    font-size: 12px;\n  }\n}\n\n@media (min-width: 1200px) {\n  .table__label {\n    min-width: 102px;\n  }\n}\n\n.table__label.-blue {\n  background-color: var(--vortex-blue);\n}\n.table__label.-dark {\n  background-color: var(--port-gore);\n}\n.table__label.-deep-blue {\n  background-color: var(--vortex-deep-blue);\n}\n.table__label.-gray {\n  background-color: var(--storm-gray);\n}\n.table__label.-green {\n  background-color: var(--vortex-green);\n}\n.table__label.-light {\n  background-color: var(--athens-gray);\n}\n.table__label.-orange {\n  background-color: var(--vortex-orange);\n}\n.table__label.-red {\n  background-color: var(--vortex-red);\n}\n",".tabs-nav {\n}\n\n.tabs-nav__item {\n  padding: 18px 5px;\n  border-bottom: 2px solid transparent;\n  color: var(--storm-gray);\n  font-size: 14px;\n  line-height: 17px;\n  font-weight: 600;\n  text-align: center;\n  transition: color 0.1s ease, border-color 0.1s ease;\n}\n\n.tabs-nav__item:hover {\n  color: rgba(var(--port-gore-rgb), 0.8);\n}\n\n.tabs-nav__item.active {\n  color: var(--vortex-deep-blue);\n  border-bottom-color: var(--vortex-deep-blue);\n}\n\n.tabs-nav__item-icon {\n  margin-right: 15px;\n  font-size: 20px;\n}\n",".true-false-toggle {\n  width: 100%;\n  display: flex;\n  padding: 6px;\n  border-radius: 5px;\n  background-color: rgba(var(--storm-gray-rgb), 0.07);\n}\n\n.true-false-toggle .btn {\n  box-shadow: 0px 2px 4px rgba(28, 23, 64, 0);\n  border-radius: 5px;\n  color: var(--storm-gray);\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 17px;\n  cursor: pointer;\n}\n\n.true-false-toggle .btn:not(.active):hover {\n  background-color: rgba(var(--vortex-deep-blue-rgb), 0.05);\n}\n\n.true-false-toggle .btn.active {\n  background: #ffffff;\n  box-shadow: 0px 2px 4px rgba(28, 23, 64, 0.05);\n  color: var(--vortex-deep-blue);\n}\n","#wrapper {\n    flex-direction: column;\n\n    @media (min-width: 992px) {\n        flex-direction: row;\n    }\n}\n\n#sidebar {\n    width: 100%;\n    top: 0;\n    width: 100%;\n    z-index: 2;\n\n    .logo {\n        display: flex;\n        justify-content: center;\n    }\n\n    @media (min-width: 992px) {\n        max-width: 280px;\n        position: sticky;\n        left: 0;\n\n        .logo {\n            display: block;\n        }\n    }\n}\n\n.navbar {\n  padding: 0 !important;\n}\n\n.main-content {\n    padding: 0 1rem 2.5rem;\n}\n\n/*\n .page-wrapper {\n  width: 100%;\n}\n\n.audience-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr;\n  grid-gap: 30px;\n  margin-top: 20px;\n  margin-bottom: 50px;\n}\n*/\n",".section {\n  &__edit-fields {\n    padding: 1.5rem;\n\n    input[type=\"text\"], textarea, select {\n      border: 1px solid rgba(var(--port-gore-rgb), 0.1);\n      box-sizing: border-box;\n      box-shadow: 0px 2px 4px rgba(var(--port-gore-rgb), 0.05);\n      border-radius: 5px;\n      color: var(--port-gore);\n      font-size: 14px;\n      line-height: 17px;\n    }\n  }\n}",".spinner-double,\n.spinner-double:after {\n  border-radius: 50%;\n  width: 10em;\n  height: 10em;\n}\n.spinner-double {\n  margin: 0 1em;\n  font-size: 10px;\n  position: relative;\n  text-indent: -9999em;\n  border-top: 1.1em solid rgba(255, 255, 255, 0.2);\n  border-right: 1.1em solid rgba(255, 255, 255, 0.2);\n  border-bottom: 1.1em solid rgba(255, 255, 255, 0.2);\n  border-left: 1.1em solid #ffffff;\n  -webkit-transform: translateZ(0);\n  -ms-transform: translateZ(0);\n  transform: translateZ(0);\n  -webkit-animation: load8 1.1s infinite linear;\n  animation: load8 1.1s infinite linear;\n}\n@-webkit-keyframes load8 {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes load8 {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n",".match-fields {\n  font-size: 0.8rem;\n}\n\n.match-field {\n  margin-left: 3em;\n  display: flex;\n  align-items: center;\n\n  &-label {\n    color: var(--storm-gray);\n    font-weight: bold;\n  }\n\n  svg {\n    margin-left: 0.5em;\n  }\n\n\n  &-value {\n    background: var(--athens-gray);\n    color: #999;\n    font-size: 0.9em;\n    margin-left: 1em;\n    padding: 0.7em 1em;\n    border-radius: 3px;\n  }\n}",".onboarding {\n  &__header {\n    border-bottom: 1px solid #e1e1e3;\n  }\n\n  &__headline {\n    font-size: 48px;\n    color: var(--vortex-deep-blue);\n  }\n\n  &__subline {\n    font-size: 21px;\n    color: var(--storm-gray);\n  }\n\n  &__divider {\n    width: 45px;\n    height: 3px;\n    background-color: #b8b8c4;\n    border: 0;\n    margin: 2em 0 3em;\n  }\n\n  &__segmentation {\n    padding: 0;\n    overflow: hidden;\n    position: relative;\n    min-height: 740px;\n\n    &__overlay {\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      z-index: 2;\n      background: rgba(33, 33, 55, 0.45);\n    }\n\n    &__bg {\n      position: absolute;\n      top: 0;\n      z-index: 1;\n      width: 100%;\n      height: 100%;\n      background-image: url('/assets/onboarding__bg.png');\n      background-repeat: no-repeat;\n      background-size: cover;\n      background-position: top;\n      /* Add the blur effect */\n      filter: blur(8px);\n      -webkit-filter: blur(8px);\n    }\n\n    &__box {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      z-index: 3;\n      position: absolute;\n      width: 80%;\n      left: 10%;\n      top: 100px;\n      padding: 3rem 2rem 2.5rem;\n      background: white;\n      border-radius: 8px;\n      box-shadow: 0 4px 18px rgba(0, 0, 0, 0.1);\n\n      img {\n        width: 80%;\n      }\n\n      header {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        h2 {\n          margin-left: 2rem;\n          margin-top: -10px;\n        }\n      }\n    }\n  }\n\n  &-btn {\n    font-size: 1.2rem;\n    padding: 1em 1.5em;\n    width: 95%;\n\n    &.selected {\n      color: #fff;\n      background-color: #343a40;\n      border-color: #343a40;\n\n      &:before {\n        position: absolute;\n        top: -1px;\n        right: -1px;\n        bottom: -1px;\n        left: -1px;\n        border-radius: 5px;\n        background-color: #000;\n        opacity: 0;\n        content: \"\";\n        z-index: -1;\n        transition: opacity 0.15s ease-in-out;\n      }\n    }\n\n    img {\n      max-height: 36px !important;\n      margin-right: 24px !important;\n      display: inline-block;\n    }\n\n    &.disabled {\n      opacity: 0.6;\n      background-color: white !important;\n      transition: none;\n\n      &:hover, &:focus-within, &:focus {\n        color: #343a40;\n        border-color: rgba(112, 110, 128, 0.1);\n        box-shadow: none;\n        background-color: white !important;\n\n        &:before, &::before {\n          transition: none;\n          background-color: white !important;\n          display: none;\n        }\n      }\n    }\n  }\n\n  &-setup-btn {\n    display: flex;\n    align-items: center;\n    padding: 1em 1.2em;\n    border: 1px solid #ccc;\n    color: var(--vortex-deep-blue);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n\n    .spinner-double {\n      font-size: 2px !important;\n      margin-left: 42px;\n    }\n\n    &:hover, &.sending {\n      background: #343a40;\n      color: white;\n      border-color: transparent;\n    }\n\n    &:disabled {\n      box-shadow: none;\n      color: var(--secondary);\n      opacity: 0.7;\n      cursor: default;\n      background: white;\n\n      &:hover {\n        box-shadow: none;\n        color: var(--secondary);\n        opacity: 0.8;\n        cursor: default;\n        border-color: #e9e9e9;\n        background: white;\n\n        &:before {\n          display: none;\n        }\n      }\n    }\n\n    .icon-arrow-right4 {\n      margin: 0 0 0 3rem !important;\n      font-size: 1rem;\n      display: inline-flex;\n    }\n\n  }\n\n  &__buttons {\n    padding: 0 2rem;\n    width: 100%;\n    display: grid;\n    grid-template-rows: 1fr 1fr;\n    grid-template-columns: 1fr 1fr;\n    grid-gap: 12x;\n\n    &-footer {\n      width: 100%;\n      display: flex;\n      justify-content: flex-end;\n    }\n  }\n}\n",".loader {\n  display: none;\n}\n\n\n/* Includes */\n.include {\n  padding: .5em;\n  display: flex;\n  flex-direction: column;\n}\n\n.include__header {\n  display: flex;\n  justify-content: space-between;\n}\n\n.include__data {\n  line-height: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  font-size: .95rem;\n}\n\n.include__data > div {\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n  word-break: break-word;\n  -ms-hyphens: auto;\n  -moz-hyphens: auto;\n  -webkit-hyphens: auto;\n  hyphens: auto;\n}\n\n.include__type {\n  font-size: 9px;\n  text-transform: capitalize;\n  padding: .6em 1em;\n  border-radius: 4px;\n  background-color: #babfc5;\n  color: var(--body-color);\n  font-weight: bold;\n  height: 25px;\n}\n\n.include__table {\n  font-size: .8rem;\n  font-weight: bold;\n  opacity: 0.35;\n  margin-top: .4em;\n}\n\n.include__description{\n  font-size: .8rem;\n  font-weight: bold;\n   opacity: 0.35;\n}\n\n\n.muted-link {\n  text-decoration: none !important;\n  color: grey !important;\n  cursor: none !important;\n}\n\n#audienceBuildAddFilterModal .select2-search--hide{\n  display: block !important;\n}\n\n#audienceBuildAddFilterModal .select2-dropdown.select2-dropdown--below{\n  height: 300px;\n}\n\n/*\n.tp-tooltip {\n  position: fixed;\n  display: flex;\n  flex-direction: column;\n  visibility: var(--tp-tooltip-content-visibility) !important;\n  z-index: 999;\n  text-transform: none;\n  color: rgba(0, 0, 0, 0.56);\n  background-color: #fff;\n  padding: 10px;\n  left: var(--tp-tooltip-content-x-position);\n  top: var(--tp-tooltip-content-y-position);\n  width: var(--tp-tooltip-content-width) !important;\n  font: 400 12px/16px Roboto, HelveticaNeue, Arial, sans-serif;\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(60, 64, 67, 0.05),\n    0 4px 8px 3px rgba(60, 64, 67, 0.15);\n}\n\n.tp-tooltip::after {\n  content: '';\n  z-index: 999;\n  visibility: var(--tp-tooltip-anchor-pointer-display-bottom);\n  border-width: 8px;\n  position: absolute;\n  left: var(--tp-tooltip-anchor-pointer-x-position);\n  top: var(--tp-tooltip-anchor-pointer-y-position);\n  border-style: solid;\n  border-color: #fff transparent transparent transparent;\n}\n\n.tp-tooltip::before {\n  content: '';\n  z-index: 999;\n  visibility: var(--tp-tooltip-anchor-pointer-display-top);\n  border-width: 8px;\n  position: absolute;\n  left: var(--tp-tooltip-anchor-pointer-x-position);\n  bottom: var(--tp-tooltip-anchor-pointer-y-position);\n  border-style: solid;\n  border-color: transparent transparent #fff transparent;\n}\n}*/\n",".form-group {\n  p {\n    font-size: 0.85rem;\n  }\n}\n\n.select2-selection {\n  &__choice {\n    background: white !important;\n    border-color: #eee !important;\n    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.08);\n    padding: .2em .8em !important;\n  }\n}\n\n.select2-container {\n  &--default {\n    &.select2-container--focus {\n      .select2-selection--multiple {\n        border-color: var(--vortex-blue) !important;\n      }\n    }\n  }\n}",".load, .loading {\n  > * {\n    display: none;\n  }\n\n  .loader {\n    display: block;\n  }\n}\n\n.loaded {\n  > * {\n    display: initial;\n  }\n\n  .loader {\n    display: none;\n  }\n}",".line-wrap {\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n  -ms-word-break: break-all;\n  word-break: break-all;\n  word-break: break-word;\n  -ms-hyphens: auto;\n  -moz-hyphens: auto;\n  -webkit-hyphens: auto;\n  hyphens: auto;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
